const vocabulary_B2 = [
    {
      "id": "1",
      "question": "toisinaan",
      "answer": "sometimes ",
      "ru": "Иногда"
    },
    {
      "id": "2",
      "question": "uneton",
      "answer": "sleepless ",
      "ru": "Бессонный"
    },
    {
      "id": "3",
      "question": "vanhempainvapaa",
      "answer": "parental leave",
      "ru": "Родительский отпуск"
    },
    {
      "id": "4",
      "question": "muualla",
      "answer": "elsewhere ",
      "ru": "В другом месте"
    },
    {
      "id": "5",
      "question": "ilo",
      "answer": "joy ",
      "ru": "Радость"
    },
    {
      "id": "6",
      "question": "iltameno",
      "answer": "evening spending",
      "ru": "Вечерняя прогулка"
    },
    {
      "id": "7",
      "question": "puolestaan",
      "answer": "in turn, on the other hand ",
      "ru": "В свою очередь"
    },
    {
      "id": "8",
      "question": "alakoulu",
      "answer": "elementary school",
      "ru": "Начальная школа"
    },
    {
      "id": "9",
      "question": "yläkoulu",
      "answer": "middle school",
      "ru": "Средняя школа"
    },
    {
      "id": "10",
      "question": "perustaa",
      "answer": "to found (establish)",
      "ru": "Основывать"
    },
    {
      "id": "11",
      "question": "ulkoilu",
      "answer": "outdoor activities",
      "ru": "Прогулки на свежем воздухе"
    },
    {
      "id": "12",
      "question": "maasto",
      "answer": "terrain",
      "ru": "Местность"
    },
    {
      "id": "13",
      "question": "vastikään",
      "answer": "recently, newly",
      "ru": "Недавно"
    },
    {
      "id": "14",
      "question": "äijä",
      "answer": "old man ",
      "ru": "Старик"
    },
    {
      "id": "15",
      "question": "sukuloida",
      "answer": "visit relatives",
      "ru": "Навещать родственников"
    },
    {
      "id": "16",
      "question": "enimmäkseen",
      "answer": "mostly ",
      "ru": "В основном"
    },
    {
      "id": "17",
      "question": "naapurusto",
      "answer": "neighborhood",
      "ru": "Соседство"
    },
    {
      "id": "18",
      "question": "hiekkalaatikko",
      "answer": "sand box ",
      "ru": "Песочница"
    },
    {
      "id": "19",
      "question": "työpaikkailmoitus",
      "answer": "job ad",
      "ru": "Объявление о работе"
    },
    {
      "id": "20",
      "question": "firma",
      "answer": "firm, company",
      "ru": "Фирма"
    },
    {
      "id": "21",
      "question": "saattaa",
      "answer": "may ",
      "ru": "Может быть"
    },
    {
      "id": "22",
      "question": "loistava",
      "answer": "excellent ",
      "ru": "Превосходный"
    },
    {
      "id": "23",
      "question": "vakio",
      "answer": "standard ",
      "ru": "Стандарт"
    },
    {
      "id": "24",
      "question": "kierros",
      "answer": "round ",
      "ru": "Раунд"
    },
    {
      "id": "25",
      "question": "toive",
      "answer": "wish",
      "ru": "Пожелание"
    },
    {
      "id": "26",
      "question": "runsaasti",
      "answer": "plenty",
      "ru": "В изобилии"
    },
    {
      "id": "27",
      "question": "räätälöidä",
      "answer": "tailor-make",
      "ru": "Адаптировать"
    },
    {
      "id": "28",
      "question": "opastus",
      "answer": "guidance ",
      "ru": "Руководство"
    },
    {
      "id": "29",
      "question": "tarjota",
      "answer": "to offer, to serve ",
      "ru": "Предлагать"
    },
    {
      "id": "30",
      "question": "tehtävä",
      "answer": "task ",
      "ru": "Задача"
    },
    {
      "id": "31",
      "question": "arvostaa",
      "answer": "to appreciate ",
      "ru": "Ценить"
    },
    {
      "id": "32",
      "question": "asenne",
      "answer": "attitude ",
      "ru": "Отношение"
    },
    {
      "id": "33",
      "question": "henkisyys",
      "answer": "spirituality",
      "ru": "Духовность"
    },
    {
      "id": "34",
      "question": "halu",
      "answer": "desire ",
      "ru": "Желание"
    },
    {
      "id": "35",
      "question": "kyky",
      "answer": "ability, talent, capacity",
      "ru": "Способность"
    },
    {
      "id": "36",
      "question": "omaksua",
      "answer": "embrace, absorb",
      "ru": "Усваивать"
    },
    {
      "id": "37",
      "question": "palvella",
      "answer": "to serve ",
      "ru": "Обслуживать"
    },
    {
      "id": "38",
      "question": "etenkin",
      "answer": "especially, in particular",
      "ru": "В особенности"
    },
    {
      "id": "39",
      "question": "edellyttää",
      "answer": "to require",
      "ru": "Требовать"
    },
    {
      "id": "40",
      "question": "sujuvasti",
      "answer": "fluently",
      "ru": "Бегло"
    },
    {
      "id": "41",
      "question": "ehdottomasti",
      "answer": "absolutely",
      "ru": "Абсолютно"
    },
    {
      "id": "42",
      "question": "olla eduksi",
      "answer": "beneficial ",
      "ru": "Быть полезным"
    },
    {
      "id": "43",
      "question": "testata",
      "answer": "to test ",
      "ru": "Тестировать"
    },
    {
      "id": "44",
      "question": "vaadittava",
      "answer": "required",
      "ru": "Требуемый"
    },
    {
      "id": "45",
      "question": "tilanne",
      "answer": "situation",
      "ru": "Ситуация"
    },
    {
      "id": "46",
      "question": "kuvata",
      "answer": "to describe, to film",
      "ru": "Описывать"
    },
    {
      "id": "47",
      "question": "joukko",
      "answer": "group",
      "ru": "Группа"
    },
    {
      "id": "48",
      "question": "mennessä",
      "answer": "by (what time) ",
      "ru": "К (какому времени)"
    },
    {
      "id": "49",
      "question": "osoittaa",
      "answer": "to show, indicate, point",
      "ru": "Показывать"
    },
    {
      "id": "50",
      "question": "viitata",
      "answer": "to refer to",
      "ru": "Ссылаться"
    },
    {
      "id": "51",
      "question": "avoin",
      "answer": "open, accessible",
      "ru": "Открытый"
    },
    {
      "id": "52",
      "question": "kokenut",
      "answer": "experienced ",
      "ru": "Опытный"
    },
    {
      "id": "53",
      "question": "käyttö",
      "answer": "use, usage",
      "ru": "Использование"
    },
    {
      "id": "54",
      "question": "vankka",
      "answer": "solid",
      "ru": "Надёжный"
    },
    {
      "id": "55",
      "question": "ammattitaito",
      "answer": "workmanship ",
      "ru": "Профессионализм"
    },
    {
      "id": "56",
      "question": "laajentaa",
      "answer": "to expand something",
      "ru": "Расширять"
    },
    {
      "id": "57",
      "question": "innostaa",
      "answer": "to inspire, to enthuse",
      "ru": "Вдохновлять"
    },
    {
      "id": "58",
      "question": "kohtaaminen",
      "answer": "rendezvous ",
      "ru": "Встреча"
    },
    {
      "id": "59",
      "question": "perehtyä",
      "answer": "to orientate oneself ",
      "ru": "Ориентироваться"
    },
    {
      "id": "60",
      "question": "ympäröidä",
      "answer": "surround ",
      "ru": "Окружать"
    },
    {
      "id": "61",
      "question": "monipuolinen",
      "answer": "versatile ",
      "ru": "Разносторонний"
    },
    {
      "id": "62",
      "question": "herättää kiinnostus",
      "answer": "arouse interest in",
      "ru": "Пробуждать интерес"
    },
    {
      "id": "63",
      "question": "perusteella",
      "answer": "on the basis of",
      "ru": "На основании"
    },
    {
      "id": "64",
      "question": "työtapa",
      "answer": "way of working",
      "ru": "Метод работы"
    },
    {
      "id": "65",
      "question": "mielekäs",
      "answer": "meaningful ",
      "ru": "Осмысленный"
    },
    {
      "id": "66",
      "question": "haastava",
      "answer": "challenging ",
      "ru": "Сложный"
    },
    {
      "id": "67",
      "question": "aiempi",
      "answer": "earlier",
      "ru": "Ранее"
    },
    {
      "id": "68",
      "question": "ansiosta",
      "answer": "thanks to ",
      "ru": "Благодаря"
    },
    {
      "id": "69",
      "question": "taito",
      "answer": "ability, skill ",
      "ru": "Навык"
    },
    {
      "id": "70",
      "question": "ruostua",
      "answer": "to rust ",
      "ru": "Ржаветь"
    },
    {
      "id": "71",
      "question": "ystäväpiiri",
      "answer": "circle of friends",
      "ru": "Круг друзей"
    },
    {
      "id": "72",
      "question": "arki",
      "answer": "daily life",
      "ru": "Будни"
    },
    {
      "id": "73",
      "question": "kautta",
      "answer": "via, through",
      "ru": "Через"
    },
    {
      "id": "74",
      "question": "vuorovaikutus",
      "answer": "interaction ",
      "ru": "Взаимодействие"
    },
    {
      "id": "75",
      "question": "kohdata",
      "answer": "to face, to encounter",
      "ru": "Встречать"
    },
    {
      "id": "76",
      "question": "kärsivällisyys",
      "answer": "patience",
      "ru": "Терпение"
    },
    {
      "id": "77",
      "question": "vahvuus",
      "answer": "strength",
      "ru": "Сила"
    },
    {
      "id": "78",
      "question": "sivutoiminen",
      "answer": "moonlighting ",
      "ru": "Дополнительная работа"
    },
    {
      "id": "79",
      "question": "päätoiminen",
      "answer": "full-time ",
      "ru": "Полная занятость"
    },
    {
      "id": "80",
      "question": "vetää",
      "answer": "to pull",
      "ru": "Тянуть"
    },
    {
      "id": "81",
      "question": "koordinaattori",
      "answer": "coordinator",
      "ru": "Координатор"
    },
    {
      "id": "82",
      "question": "lehtinen",
      "answer": "leaflet ",
      "ru": "Листовка"
    },
    {
      "id": "83",
      "question": "toimittaminen",
      "answer": "provision ",
      "ru": "Предоставление"
    },
    {
      "id": "84",
      "question": "yksityisopettaja",
      "answer": "tutor",
      "ru": "Репетитор"
    },
    {
      "id": "85",
      "question": "pääaine ",
      "answer": "major ",
      "ru": "Основной предмет"
    },
    {
      "id": "86",
      "question": "ohjelmointi",
      "answer": "programming ",
      "ru": "Программирование"
    },
    {
      "id": "87",
      "question": "peruste",
      "answer": "reason, justification",
      "ru": "Основание"
    },
    {
      "id": "88",
      "question": "aktiivinen",
      "answer": "active",
      "ru": "Активный"
    },
    {
      "id": "89",
      "question": "luonteva",
      "answer": "natural",
      "ru": "Естественный"
    },
    {
      "id": "90",
      "question": "luottamus",
      "answer": "trust, confidence ",
      "ru": "Доверие"
    },
    {
      "id": "91",
      "question": "seura",
      "answer": "company, association",
      "ru": "Компания"
    },
    {
      "id": "92",
      "question": "jäsen",
      "answer": "member",
      "ru": "Член"
    },
    {
      "id": "93",
      "question": "palkansaaja",
      "answer": "wage earner, employee",
      "ru": "Наёмный работник"
    },
    {
      "id": "94",
      "question": "yrittäjä",
      "answer": "entrepreneur, co-founder",
      "ru": "Предприниматель"
    },
    {
      "id": "95",
      "question": "pienyrittäjä",
      "answer": "small business man",
      "ru": "Малый предприниматель"
    },
    {
      "id": "96",
      "question": "yhtiö",
      "answer": "company, corporation, partnership",
      "ru": "Общество"
    },
    {
      "id": "97",
      "question": "osakeyhtiö",
      "answer": "limited company ",
      "ru": "Акционерное общество"
    },
    {
      "id": "98",
      "question": "toiminimi",
      "answer": "trade name",
      "ru": "Торговое имя"
    },
    {
      "id": "99",
      "question": "esimies",
      "answer": "boss, manager",
      "ru": "Начальник"
    },
    {
      "id": "100",
      "question": "päällikkö ",
      "answer": "chief, head",
      "ru": "Руководитель"
    },
    {
      "id": "101",
      "question": "työnjohtaja",
      "answer": "foreman ",
      "ru": "Бригадир"
    },
    {
      "id": "102",
      "question": "palkka",
      "answer": "reward, fee ",
      "ru": "Зарплата"
    },
    {
      "id": "103",
      "question": "tuntipalkka",
      "answer": "hourly wage ",
      "ru": "Почасовая оплата"
    },
    {
      "id": "104",
      "question": "kuukausipalkka",
      "answer": "salary ",
      "ru": "Месячная зарплата"
    },
    {
      "id": "105",
      "question": "palkankorotus",
      "answer": "pay rise ",
      "ru": "Повышение зарплаты"
    },
    {
      "id": "106",
      "question": "lomaraha",
      "answer": "holiday pay",
      "ru": "Отпускные"
    },
    {
      "id": "107",
      "question": "työsuhde",
      "answer": "employment relationship",
      "ru": "Трудовые отношения"
    },
    {
      "id": "108",
      "question": "määräaikainen",
      "answer": "fix-term, temporary",
      "ru": "Срочный"
    },
    {
      "id": "109",
      "question": "vakituinen",
      "answer": "permanent",
      "ru": "Постоянный"
    },
    {
      "id": "110",
      "question": "osa-aikainen",
      "answer": "part-time  ",
      "ru": "Частичная занятость"
    },
    {
      "id": "111",
      "question": "kokopäivätyö",
      "answer": "full-time job ",
      "ru": "Работа на полный день"
    },
    {
      "id": "112",
      "question": "osa-aikatyö",
      "answer": "part-time job",
      "ru": "Работа на неполный день"
    },
    {
      "id": "113",
      "question": "pätkätyö",
      "answer": "temporary work",
      "ru": "Временная работа"
    },
    {
      "id": "114",
      "question": "etätyö",
      "answer": "work from home",
      "ru": "Удалённая работа"
    },
    {
      "id": "115",
      "question": "vuorotyö ",
      "answer": "shift work ",
      "ru": "Сменная работа"
    },
    {
      "id": "116",
      "question": "sairausloma",
      "answer": "sick leave",
      "ru": "Больничный"
    },
    {
      "id": "117",
      "question": "vuosiloma",
      "answer": "annual leave",
      "ru": "Ежегодный отпуск"
    },
    {
      "id": "118",
      "question": "irtisanoa",
      "answer": "to fire, terminate from job",
      "ru": "Увольнять"
    },
    {
      "id": "119",
      "question": "irtisanoutua",
      "answer": "to resign",
      "ru": "Увольняться"
    },
    {
      "id": "120",
      "question": "irtisanomisaika",
      "answer": "notice",
      "ru": "Период уведомления"
    },
    {
      "id": "121",
      "question": "ammattiyhdistys",
      "answer": "labor union",
      "ru": "Профсоюз"
    },
    {
      "id": "122",
      "question": "luottamusmies",
      "answer": "shop steward",
      "ru": "Профорг"
    },
    {
      "id": "123",
      "question": "toimi",
      "answer": "chore, job, duty, action ",
      "ru": "Должность"
    },
    {
      "id": "124",
      "question": "työnhakija",
      "answer": "job hunter",
      "ru": "Соискатель"
    },
    {
      "id": "125",
      "question": "tietotaito",
      "answer": "know-how ",
      "ru": "Ноу-хау"
    },
    {
      "id": "126",
      "question": "merkittävä",
      "answer": "significant",
      "ru": "Значительный"
    },
    {
      "id": "127",
      "question": "terva",
      "answer": "tar",
      "ru": "Смола"
    },
    {
      "id": "128",
      "question": "ylivoimainen",
      "answer": "superior ",
      "ru": "Превосходящий"
    },
    {
      "id": "129",
      "question": "viejä",
      "answer": "exporter",
      "ru": "Экспортёр"
    },
    {
      "id": "130",
      "question": "alihankkija",
      "answer": "subcontractor ",
      "ru": "Субподрядчик"
    },
    {
      "id": "131",
      "question": "alun perin",
      "answer": "originally",
      "ru": "Первоначально"
    },
    {
      "id": "132",
      "question": "tuotekehitys",
      "answer": "product development",
      "ru": "Разработка продукта"
    },
    {
      "id": "133",
      "question": "kirkonkylä",
      "answer": "village with a church",
      "ru": "Церковная деревня"
    },
    {
      "id": "134",
      "question": "saamelainen",
      "answer": "Sami/Lapp",
      "ru": "Саами"
    },
    {
      "id": "135",
      "question": "poro",
      "answer": "reindeer ",
      "ru": "Олень"
    },
    {
      "id": "136",
      "question": "alkuperäiskansa",
      "answer": "native people",
      "ru": "Коренной народ"
    },
    {
      "id": "137",
      "question": "elvyttää",
      "answer": "to revive ",
      "ru": "Возрождать"
    },
    {
      "id": "138",
      "question": "turvata",
      "answer": "to secure, protect",
      "ru": "Обеспечивать"
    },
    {
      "id": "139",
      "question": "perusopetus",
      "answer": "primary school education",
      "ru": "Начальное образование"
    },
    {
      "id": "140",
      "question": "tulla voimaan",
      "answer": "come into force",
      "ru": "Вступать в силу"
    },
    {
      "id": "141",
      "question": "viranomainen",
      "answer": "official, authority",
      "ru": "Должностное лицо"
    },
    {
      "id": "142",
      "question": "asioida",
      "answer": "to do business",
      "ru": "Вести дела"
    },
    {
      "id": "143",
      "question": "käytännössä",
      "answer": "practically ",
      "ru": "На практике"
    },
    {
      "id": "144",
      "question": "toteutua",
      "answer": "to come true ",
      "ru": "Осуществляться"
    },
    {
      "id": "145",
      "question": "kalastus",
      "answer": "fishing ",
      "ru": "Рыболовство"
    },
    {
      "id": "146",
      "question": "metsästys",
      "answer": "hunting ",
      "ru": "Охота"
    },
    {
      "id": "147",
      "question": "vaellus",
      "answer": "wandering, migration, hike",
      "ru": "Поход"
    },
    {
      "id": "148",
      "question": "reitti",
      "answer": "route ",
      "ru": "Маршрут"
    },
    {
      "id": "149",
      "question": "kierrellä",
      "answer": "to walk around ",
      "ru": "Ходить вокруг"
    },
    {
      "id": "150",
      "question": "vaeltaminen",
      "answer": "hiking ",
      "ru": "Пешеходный туризм"
    },
    {
      "id": "151",
      "question": "kulkea",
      "answer": "to go by",
      "ru": "Идти"
    },
    {
      "id": "152",
      "question": "vesistö",
      "answer": "waters",
      "ru": "Водный бассейн"
    },
    {
      "id": "153",
      "question": "seurata",
      "answer": "to follow",
      "ru": "Следовать"
    },
    {
      "id": "154",
      "question": "retkeily",
      "answer": "camping",
      "ru": "Поход"
    },
    {
      "id": "155",
      "question": "merkitä",
      "answer": "to write down, matter",
      "ru": "Отмечать"
    },
    {
      "id": "156",
      "question": "viitta",
      "answer": "cloak",
      "ru": "Плащ"
    },
    {
      "id": "157",
      "question": "eksyä",
      "answer": "to get lost",
      "ru": "Заблудиться"
    },
    {
      "id": "158",
      "question": "vaara",
      "answer": "danger, wrong",
      "ru": "Опасность"
    },
    {
      "id": "159",
      "question": "autiotupa",
      "answer": "free hut",
      "ru": "Свободная хижина"
    },
    {
      "id": "160",
      "question": "laavu",
      "answer": "shelter",
      "ru": "Навес"
    },
    {
      "id": "161",
      "question": "välein",
      "answer": "every ",
      "ru": "Через"
    },
    {
      "id": "162",
      "question": "kuru",
      "answer": "gulch, gorge",
      "ru": "Ущелье"
    },
    {
      "id": "163",
      "question": "virrata",
      "answer": "to flow, run",
      "ru": "Течь"
    },
    {
      "id": "164",
      "question": "jylhä",
      "answer": "rocky, rugged",
      "ru": "Суровый"
    },
    {
      "id": "165",
      "question": "harju",
      "answer": "ridge",
      "ru": "Гряда"
    },
    {
      "id": "166",
      "question": "kangas",
      "answer": "fabric ",
      "ru": "Ткань"
    },
    {
      "id": "167",
      "question": "arvokas",
      "answer": "dignified ",
      "ru": "Ценный"
    },
    {
      "id": "168",
      "question": "kuluminen",
      "answer": "wearing",
      "ru": "Износ"
    },
    {
      "id": "169",
      "question": "pysyä",
      "answer": "to remain, stay",
      "ru": "Оставаться"
    },
    {
      "id": "170",
      "question": "pitkospuut",
      "answer": "duckboards",
      "ru": "Настил"
    },
    {
      "id": "171",
      "question": "riippusilta",
      "answer": "hanging bridge",
      "ru": "Подвесной мост"
    },
    {
      "id": "172",
      "question": "matkailukohde",
      "answer": "tourist destination",
      "ru": "Туристическое место"
    },
    {
      "id": "173",
      "question": "muodostelma",
      "answer": "formation",
      "ru": "Формация"
    },
    {
      "id": "174",
      "question": "henkeäsalpaava",
      "answer": "breathtaking",
      "ru": "Захватывающий дух"
    },
    {
      "id": "175",
      "question": "näköala",
      "answer": "view, scene",
      "ru": "Вид"
    },
    {
      "id": "176",
      "question": "muodostua",
      "answer": "to be formed",
      "ru": "Формироваться"
    },
    {
      "id": "177",
      "question": "repiä",
      "answer": "to tear ",
      "ru": "Рвать"
    },
    {
      "id": "178",
      "question": "silottaa",
      "answer": "to sleek",
      "ru": "Разглаживать"
    },
    {
      "id": "179",
      "question": "sulaa",
      "answer": "to melt ",
      "ru": "Таять"
    },
    {
      "id": "180",
      "question": "reuna",
      "answer": "edge ",
      "ru": "Край"
    },
    {
      "id": "181",
      "question": "maa",
      "answer": "country, land",
      "ru": "Страна"
    },
    {
      "id": "182",
      "question": "viehättää",
      "answer": "to attract",
      "ru": "Привлекать"
    },
    {
      "id": "183",
      "question": "vuosisata",
      "answer": "century ",
      "ru": "Век"
    },
    {
      "id": "184",
      "question": "inspiroida",
      "answer": "to inspire ",
      "ru": "Вдохновлять"
    },
    {
      "id": "185",
      "question": "historioitsija",
      "answer": "historian ",
      "ru": "Историк"
    },
    {
      "id": "186",
      "question": "pitkälti",
      "answer": "to a large extent",
      "ru": "В значительной степени"
    },
    {
      "id": "187",
      "question": "kivi",
      "answer": "stone ",
      "ru": "Камень"
    },
    {
      "id": "188",
      "question": "hiekka",
      "answer": "sand ",
      "ru": "Песок"
    },
    {
      "id": "189",
      "question": "maaperä",
      "answer": "ground , soil",
      "ru": "Почва"
    },
    {
      "id": "190",
      "question": "suo",
      "answer": "bog , swamp",
      "ru": "Болото"
    },
    {
      "id": "191",
      "question": "pelto",
      "answer": "field ",
      "ru": "Поле"
    },
    {
      "id": "192",
      "question": "niitty",
      "answer": "meadow",
      "ru": "Луг"
    },
    {
      "id": "193",
      "question": "metsä",
      "answer": "forest",
      "ru": "Лес"
    },
    {
      "id": "194",
      "question": "havumetsä",
      "answer": "coniferous forest ",
      "ru": "Хвойный лес"
    },
    {
      "id": "195",
      "question": "lehtimetsä",
      "answer": "deciduous forest",
      "ru": "Лиственный лес"
    },
    {
      "id": "196",
      "question": "sekametsä",
      "answer": "mixed forest",
      "ru": "Смешанный лес"
    },
    {
      "id": "197",
      "question": "rinne",
      "answer": "slope, hillside",
      "ru": "Склон"
    },
    {
      "id": "198",
      "question": "kukkula",
      "answer": "hill",
      "ru": "Холм"
    },
    {
      "id": "199",
      "question": "vuori",
      "answer": "mountain",
      "ru": "Гора"
    },
    {
      "id": "200",
      "question": "laakso",
      "answer": "valley ",
      "ru": "Долина"
    },
    {
      "id": "201",
      "question": "autiomaa",
      "answer": "desert ",
      "ru": "Пустыня"
    },
    {
      "id": "202",
      "question": "viidakko",
      "answer": "jungle",
      "ru": "Джунгли"
    },
    {
      "id": "203",
      "question": "sademetsä",
      "answer": "rain forest ",
      "ru": "Тропический лес"
    },
    {
      "id": "204",
      "question": "erämaa",
      "answer": "wilderness",
      "ru": "Дикая природа"
    },
    {
      "id": "205",
      "question": "tundra ",
      "answer": "tundra ",
      "ru": "Тундра"
    },
    {
      "id": "206",
      "question": "valtameri",
      "answer": "ocean",
      "ru": "Океан"
    },
    {
      "id": "207",
      "question": "meri",
      "answer": "sea",
      "ru": "Море"
    },
    {
      "id": "208",
      "question": "järvi",
      "answer": "lake ",
      "ru": "Озеро"
    },
    {
      "id": "209",
      "question": "lampi",
      "answer": "small forest lake, pond",
      "ru": "Лесное озеро"
    },
    {
      "id": "210",
      "question": "puro",
      "answer": "stream ",
      "ru": "Ручей"
    },
    {
      "id": "211",
      "question": "koski",
      "answer": "rapid ",
      "ru": "Порог"
    },
    {
      "id": "212",
      "question": "sisämaa",
      "answer": "inland ",
      "ru": "Внутренние районы"
    },
    {
      "id": "213",
      "question": "saaristo",
      "answer": "archipelago ",
      "ru": "Архипелаг"
    },
    {
      "id": "214",
      "question": "vuoristo",
      "answer": "mountains ",
      "ru": "Горная местность"
    },
    {
      "id": "215",
      "question": "tasanko",
      "answer": "plateau",
      "ru": "Плато"
    },
    {
      "id": "216",
      "question": "alanko",
      "answer": "lowland",
      "ru": "Низменность"
    },
    {
      "id": "217",
      "question": "ylänkö",
      "answer": "highland",
      "ru": "Нагорье"
    },
    {
      "id": "218",
      "question": "saari",
      "answer": "island ",
      "ru": "Остров"
    },
    {
      "id": "219",
      "question": "kaupunki",
      "answer": "city ",
      "ru": "Город"
    },
    {
      "id": "220",
      "question": "maaseutu",
      "answer": "countryside ",
      "ru": "Сельская местность"
    },
    {
      "id": "221",
      "question": "taajama",
      "answer": "population centre",
      "ru": "Населённый пункт"
    },
    {
      "id": "222",
      "question": "elinkeino",
      "answer": "source of livelihood, line of business",
      "ru": "Средство к существованию"
    },
    {
      "id": "223",
      "question": "teollisuus",
      "answer": "industry ",
      "ru": "Промышленность"
    },
    {
      "id": "224",
      "question": "metsätalous",
      "answer": "forestry ",
      "ru": "Лесное хозяйство"
    },
    {
      "id": "225",
      "question": "rakentaminen",
      "answer": "building, construction",
      "ru": "Строительство"
    },
    {
      "id": "226",
      "question": "maatalous",
      "answer": "agriculture ",
      "ru": "Сельское хозяйство"
    },
    {
      "id": "227",
      "question": "palveluala",
      "answer": "service industry ",
      "ru": "Сфера услуг"
    },
    {
      "id": "228",
      "question": "tutkimus",
      "answer": "research ",
      "ru": "Исследование"
    },
    {
      "id": "229",
      "question": "teknologia",
      "answer": "technology ",
      "ru": "Технология"
    },
    {
      "id": "230",
      "question": "innovaatio",
      "answer": "innovation",
      "ru": "Инновация"
    },
    {
      "id": "231",
      "question": "sektori",
      "answer": "sector",
      "ru": "Сектор"
    },
    {
      "id": "232",
      "question": "bruttokansantuote",
      "answer": "GDP ",
      "ru": "ВВП"
    },
    {
      "id": "233",
      "question": "luonnonvarat",
      "answer": "natural resources",
      "ru": "Природные ресурсы"
    },
    {
      "id": "234",
      "question": "vienti",
      "answer": "export",
      "ru": "Экспорт"
    },
    {
      "id": "235",
      "question": "tuonti",
      "answer": "import ",
      "ru": "Импорт"
    },
    {
      "id": "236",
      "question": "ulkomaankauppa",
      "answer": "foreign trade ",
      "ru": "Внешняя торговля"
    },
    {
      "id": "237",
      "question": "talouskasvu",
      "answer": "economic growth",
      "ru": "Экономический рост"
    },
    {
      "id": "238",
      "question": "työvoima",
      "answer": "labour force ",
      "ru": "Рабочая сила"
    },
    {
      "id": "239",
      "question": "työllisyys",
      "answer": "employment ",
      "ru": "Занятость"
    },
    {
      "id": "240",
      "question": "taantuma",
      "answer": "recession, depression",
      "ru": "Спад"
    },
    {
      "id": "241",
      "question": "punoittaa",
      "answer": "to blush ",
      "ru": "Краснеть"
    },
    {
      "id": "242",
      "question": "pamppailla",
      "answer": "to beat ",
      "ru": "Биться"
    },
    {
      "id": "243",
      "question": "loistaa",
      "answer": "to shine, glow",
      "ru": "Сиять"
    },
    {
      "id": "244",
      "question": "lihavoitu",
      "answer": "bold ",
      "ru": "Жирный"
    },
    {
      "id": "245",
      "question": "poikkeus",
      "answer": "exception",
      "ru": "Исключение"
    },
    {
      "id": "246",
      "question": "kunnia",
      "answer": "honor, glory",
      "ru": "Честь"
    },
    {
      "id": "247",
      "question": "herkku",
      "answer": "delicacy ",
      "ru": "Лакомство"
    },
    {
      "id": "248",
      "question": "kattaa",
      "answer": "to set, cover",
      "ru": "Накрывать"
    },
    {
      "id": "249",
      "question": "saada selville",
      "answer": "to get to know, find out",
      "ru": "Узнать"
    },
    {
      "id": "250",
      "question": "välittää",
      "answer": "to transmit, convey",
      "ru": "Передавать"
    },
    {
      "id": "251",
      "question": "vaikeus",
      "answer": "difficulty ",
      "ru": "Трудность"
    },
    {
      "id": "252",
      "question": "vilkuilla",
      "answer": "to glance, squint",
      "ru": "Поглядывать"
    },
    {
      "id": "253",
      "question": "mietiskellä",
      "answer": "to meditate, ponder",
      "ru": "Размышлять"
    },
    {
      "id": "254",
      "question": "astella",
      "answer": "to step , pace, advance slowly",
      "ru": "Шагать"
    },
    {
      "id": "255",
      "question": "kehottaa",
      "answer": "to urge, admonish",
      "ru": "Призывать"
    },
    {
      "id": "256",
      "question": "pelkästään",
      "answer": "merely ",
      "ru": "Лишь"
    },
    {
      "id": "257",
      "question": "aikamoinen",
      "answer": "quite some ",
      "ru": "Немалый"
    },
    {
      "id": "258",
      "question": "käänteentekevä",
      "answer": "pivotal , revolutionary",
      "ru": "Переломный"
    },
    {
      "id": "259",
      "question": "ulkopuolinen",
      "answer": "external ",
      "ru": "Внешний"
    },
    {
      "id": "260",
      "question": "kielimuuri",
      "answer": "language barrier",
      "ru": "Языковой барьер"
    },
    {
      "id": "261",
      "question": "aueta",
      "answer": "open, hatch, unfold",
      "ru": "Открываться"
    },
    {
      "id": "262",
      "question": "verkosto",
      "answer": "network, connections ",
      "ru": "Сеть"
    },
    {
      "id": "263",
      "question": "samankaltainen",
      "answer": "similar ",
      "ru": "Похожий"
    },
    {
      "id": "264",
      "question": "kirjava",
      "answer": "multicoloured ",
      "ru": "Пёстрый"
    },
    {
      "id": "265",
      "question": "risteily",
      "answer": "cruise",
      "ru": "Круиз"
    },
    {
      "id": "266",
      "question": "malttaa",
      "answer": "to have patience  ",
      "ru": "Терпеть"
    },
    {
      "id": "267",
      "question": "noutopöytä",
      "answer": "buffet",
      "ru": "Шведский стол"
    },
    {
      "id": "268",
      "question": "aplodit",
      "answer": "applause",
      "ru": "Аплодисменты"
    },
    {
      "id": "269",
      "question": "mieletön",
      "answer": "absurd, mindless",
      "ru": "Безумный"
    },
    {
      "id": "270",
      "question": "sattua",
      "answer": "to occur ",
      "ru": "Случаться"
    },
    {
      "id": "271",
      "question": "lammas",
      "answer": "sheep ",
      "ru": "Овца"
    },
    {
      "id": "272",
      "question": "maalaistalo",
      "answer": "country house ",
      "ru": "Сельский дом"
    },
    {
      "id": "273",
      "question": "emäntä",
      "answer": "mistress, hostess, matron",
      "ru": "Хозяйка"
    },
    {
      "id": "274",
      "question": "törmätä",
      "answer": "to impact, crash, bump into",
      "ru": "Столкнуться"
    },
    {
      "id": "275",
      "question": "orpo",
      "answer": "orphan ",
      "ru": "Сирота"
    },
    {
      "id": "276",
      "question": "puuhata",
      "answer": "to be busy with",
      "ru": "Заниматься"
    },
    {
      "id": "277",
      "question": "varoitusaika",
      "answer": "reluctant",
      "ru": "Время предупреждения"
    },
    {
      "id": "278",
      "question": "teini",
      "answer": "teenager",
      "ru": "Подросток"
    },
    {
      "id": "279",
      "question": "kurjuus",
      "answer": "misery ",
      "ru": "Нищета"
    },
    {
      "id": "280",
      "question": "osittain",
      "answer": "partially",
      "ru": "Частично"
    },
    {
      "id": "281",
      "question": "kotouttaminen",
      "answer": "social integration",
      "ru": "Социальная интеграция"
    },
    {
      "id": "282",
      "question": "näköjään",
      "answer": "seemingly ",
      "ru": "По-видимому"
    },
    {
      "id": "283",
      "question": "kuvio",
      "answer": "pattern",
      "ru": "Узор"
    },
    {
      "id": "284",
      "question": "uteliaisuus",
      "answer": "curiosity",
      "ru": "Любопытство"
    },
    {
      "id": "285",
      "question": "maistella",
      "answer": "to taste ",
      "ru": "Пробовать на вкус"
    },
    {
      "id": "286",
      "question": "työsopimus ",
      "answer": "work contract",
      "ru": "Трудовой договор"
    },
    {
      "id": "287",
      "question": "perehdytys",
      "answer": "induction",
      "ru": "Ввод в должность"
    },
    {
      "id": "288",
      "question": "koeaika",
      "answer": "probation",
      "ru": "Испытательный срок"
    },
    {
      "id": "289",
      "question": "osaaminen",
      "answer": "know-how",
      "ru": "Умения"
    },
    {
      "id": "290",
      "question": "hallinta",
      "answer": "mastery, control, dominion",
      "ru": "Владение"
    },
    {
      "id": "291",
      "question": "hallita",
      "answer": "to dominate ",
      "ru": "Управлять"
    },
    {
      "id": "292",
      "question": "oma-aloitteinen",
      "answer": "spontaneous",
      "ru": "Инициативный"
    },
    {
      "id": "293",
      "question": "itsenäinen",
      "answer": "independent ",
      "ru": "Независимый"
    },
    {
      "id": "294",
      "question": "yhteistyökykyinen",
      "answer": "cooperative ",
      "ru": "Способный к сотрудничеству"
    },
    {
      "id": "295",
      "question": "joustava",
      "answer": "flexible",
      "ru": "Гибкий"
    },
    {
      "id": "296",
      "question": "sitoutunut",
      "answer": "committed",
      "ru": "Преданный"
    },
    {
      "id": "297",
      "question": "motivoitunut",
      "answer": "motivated",
      "ru": "Мотивированный"
    },
    {
      "id": "298",
      "question": "määrätietoinen",
      "answer": "determined ",
      "ru": "Целеустремлённый"
    },
    {
      "id": "299",
      "question": "ahkera",
      "answer": "diligent ",
      "ru": "Прилежный"
    },
    {
      "id": "300",
      "question": "täsmällinen",
      "answer": "exact, precise",
      "ru": "Точный"
    },
    {
      "id": "301",
      "question": "huolellinen",
      "answer": "careful ",
      "ru": "Тщательный"
    },
    {
      "id": "302",
      "question": "järjestelmällinen",
      "answer": "systematic, organized",
      "ru": "Систематический"
    },
    {
      "id": "303",
      "question": "luova",
      "answer": "creative ",
      "ru": "Творческий"
    },
    {
      "id": "304",
      "question": "yhdistää",
      "answer": "to combine ",
      "ru": "Объединять"
    },
    {
      "id": "305",
      "question": "hyökätä",
      "answer": "to attack",
      "ru": "Нападать"
    },
    {
      "id": "306",
      "question": "surra",
      "answer": "to mourn ",
      "ru": "Скорбеть"
    },
    {
      "id": "307",
      "question": "häikäistä",
      "answer": "to dazzle",
      "ru": "Ослеплять"
    },
    {
      "id": "308",
      "question": "käskeä",
      "answer": "to order ",
      "ru": "Приказывать"
    },
    {
      "id": "309",
      "question": "järkyttää",
      "answer": "to shock, upset",
      "ru": "Потрясать"
    },
    {
      "id": "310",
      "question": "toistua",
      "answer": "to repeat ",
      "ru": "Повторяться"
    },
    {
      "id": "311",
      "question": "liikkua",
      "answer": "to move; to exercise",
      "ru": "Двигаться"
    },
    {
      "id": "312",
      "question": "loukata",
      "answer": "to infringe, to violate",
      "ru": "Обижать"
    },
    {
      "id": "313",
      "question": "kiukutella",
      "answer": "to crank , act up",
      "ru": "Капризничать"
    },
    {
      "id": "314",
      "question": "vapista",
      "answer": "to shiver, tremble",
      "ru": "Дрожать"
    },
    {
      "id": "315",
      "question": "kiehua",
      "answer": "to boil ",
      "ru": "Кипеть"
    },
    {
      "id": "316",
      "question": "vaihdella",
      "answer": "to vary ",
      "ru": "Варьироваться"
    },
    {
      "id": "317",
      "question": "miellyttää",
      "answer": "to please ",
      "ru": "Нравиться"
    },
    {
      "id": "318",
      "question": "myrskytä",
      "answer": "storm",
      "ru": "Бушевать"
    },
    {
      "id": "319",
      "question": "ratas",
      "answer": "wheel ",
      "ru": "Колесо"
    },
    {
      "id": "320",
      "question": "kirkas",
      "answer": "bright, radiant ",
      "ru": "Яркий"
    },
    {
      "id": "321",
      "question": "sympaattinen",
      "answer": "sympathetic ",
      "ru": "Симпатичный"
    },
    {
      "id": "322",
      "question": "upseeri",
      "answer": "officer",
      "ru": "Офицер"
    },
    {
      "id": "323",
      "question": "haukkumasana",
      "answer": "term of abuse ",
      "ru": "Оскорбление"
    },
    {
      "id": "324",
      "question": "erikoinen",
      "answer": "special",
      "ru": "Особый"
    },
    {
      "id": "325",
      "question": "anomus",
      "answer": "plea, application",
      "ru": "Прошение"
    },
    {
      "id": "326",
      "question": "vaatimus",
      "answer": "requirement",
      "ru": "Требование"
    },
    {
      "id": "327",
      "question": "kera",
      "answer": "with",
      "ru": "С"
    },
    {
      "id": "328",
      "question": "varoitus",
      "answer": "warning ",
      "ru": "Предупреждение"
    },
    {
      "id": "329",
      "question": "tulostus",
      "answer": "printout , output",
      "ru": "Распечатка"
    },
    {
      "id": "330",
      "question": "hiukan",
      "answer": "a little ",
      "ru": "Немного"
    },
    {
      "id": "331",
      "question": "rasittaa",
      "answer": "to wear, strain",
      "ru": "Изнурять"
    },
    {
      "id": "332",
      "question": "palava",
      "answer": "burning ",
      "ru": "Горящий"
    },
    {
      "id": "333",
      "question": "muodikas",
      "answer": "fashionable ",
      "ru": "Модный"
    },
    {
      "id": "334",
      "question": "vallitseva",
      "answer": "dominant",
      "ru": "Преобладающий"
    },
    {
      "id": "335",
      "question": "nimenomaan",
      "answer": "expressly ",
      "ru": "Именно"
    },
    {
      "id": "336",
      "question": "haave",
      "answer": "dream ",
      "ru": "Мечта"
    },
    {
      "id": "337",
      "question": "mahtava",
      "answer": "awesome ",
      "ru": "Великолепный"
    },
    {
      "id": "338",
      "question": "työsopimus",
      "answer": "work contract ",
      "ru": "Трудовой договор"
    },
    {
      "id": "339",
      "question": "työhöntulokeskustelu",
      "answer": "pre-employment discussion",
      "ru": "Беседа при приёме на работу"
    },
    {
      "id": "340",
      "question": "käytännön",
      "answer": "practical ",
      "ru": "Практический"
    },
    {
      "id": "341",
      "question": "ottaa yhteyttä",
      "answer": "to contact ",
      "ru": "Связаться"
    },
    {
      "id": "342",
      "question": "toimistopäällikkö",
      "answer": "office manager ",
      "ru": "Офис-менеджер"
    },
    {
      "id": "343",
      "question": "mikäli",
      "answer": "if in case , if, provided that",
      "ru": "Если"
    },
    {
      "id": "344",
      "question": "varma",
      "answer": "certain, sure",
      "ru": "Уверенный"
    },
    {
      "id": "345",
      "question": "netti",
      "answer": "internet ",
      "ru": "Интернет"
    },
    {
      "id": "346",
      "question": "tehokas",
      "answer": "effective ",
      "ru": "Эффективный"
    },
    {
      "id": "347",
      "question": "tajuta",
      "answer": "to realize",
      "ru": "Осознать"
    },
    {
      "id": "348",
      "question": "kauhea",
      "answer": "horrible",
      "ru": "Ужасный"
    },
    {
      "id": "349",
      "question": "päivähoito",
      "answer": "daycare",
      "ru": "Детский сад"
    },
    {
      "id": "350",
      "question": "tarve",
      "answer": "need ",
      "ru": "Потребность"
    },
    {
      "id": "351",
      "question": "äkillinen",
      "answer": "sudden ",
      "ru": "Внезапный"
    },
    {
      "id": "352",
      "question": "johtua",
      "answer": "to result from ",
      "ru": "Вытекать"
    },
    {
      "id": "353",
      "question": "työllistyminen",
      "answer": "employment",
      "ru": "Трудоустройство"
    },
    {
      "id": "354",
      "question": "kunnallinen",
      "answer": "municipal ",
      "ru": "Муниципальный"
    },
    {
      "id": "355",
      "question": "kirjallinen",
      "answer": "writing ",
      "ru": "Письменный"
    },
    {
      "id": "356",
      "question": "yksityinen",
      "answer": "private",
      "ru": "Частный"
    },
    {
      "id": "357",
      "question": "ensisijainen",
      "answer": "primary ",
      "ru": "Первоочередной"
    },
    {
      "id": "358",
      "question": "sähköinen",
      "answer": "electric ",
      "ru": "Электронный"
    },
    {
      "id": "359",
      "question": "rekisteröityä",
      "answer": "register ",
      "ru": "Регистрироваться"
    },
    {
      "id": "360",
      "question": "palvelu",
      "answer": "service",
      "ru": "Услуга"
    },
    {
      "id": "361",
      "question": "tunnistautuminen",
      "answer": "authentication",
      "ru": "Аутентификация"
    },
    {
      "id": "362",
      "question": "siirtyä",
      "answer": "to move, to shift",
      "ru": "Переходить"
    },
    {
      "id": "363",
      "question": "hakija",
      "answer": "candidate, seeker",
      "ru": "Кандидат"
    },
    {
      "id": "364",
      "question": "kohta",
      "answer": "soon, paragraph, place, section",
      "ru": "Скоро"
    },
    {
      "id": "365",
      "question": "puutteellinen",
      "answer": "insufficient ",
      "ru": "Недостаточный"
    },
    {
      "id": "366",
      "question": "johtaa",
      "answer": "to lead ",
      "ru": "Вести"
    },
    {
      "id": "367",
      "question": "käsittely",
      "answer": "treatment ",
      "ru": "Обработка"
    },
    {
      "id": "368",
      "question": "viivästyminen",
      "answer": "delay ",
      "ru": "Задержка"
    },
    {
      "id": "369",
      "question": "kirjata",
      "answer": "to register, enter",
      "ru": "Регистрировать"
    },
    {
      "id": "370",
      "question": "ottaa huomioon",
      "answer": "to take into consideration",
      "ru": "Принимать во внимание"
    },
    {
      "id": "371",
      "question": "mahdollisimman",
      "answer": "as possible",
      "ru": "Насколько возможно"
    },
    {
      "id": "372",
      "question": "yksikkö",
      "answer": "singular, unit, section",
      "ru": "Единица"
    },
    {
      "id": "373",
      "question": "huomioida",
      "answer": "to pay attention",
      "ru": "Учитывать"
    },
    {
      "id": "374",
      "question": "sitova",
      "answer": "obligatory ",
      "ru": "Обязательный"
    },
    {
      "id": "375",
      "question": "varaus",
      "answer": "reservation",
      "ru": "Резервирование"
    },
    {
      "id": "376",
      "question": "ilmoitettu",
      "answer": "announced ",
      "ru": "Объявленный"
    },
    {
      "id": "377",
      "question": "perumaton",
      "answer": "uncancelled ",
      "ru": "Неотменённый"
    },
    {
      "id": "378",
      "question": "periä",
      "answer": "to charge, to collect",
      "ru": "Взимать"
    },
    {
      "id": "379",
      "question": "tyytymätön",
      "answer": "dissatisfied ",
      "ru": "Недовольный"
    },
    {
      "id": "380",
      "question": "osoitettu",
      "answer": "proven, addressed",
      "ru": "Адресованный"
    },
    {
      "id": "381",
      "question": "tekija",
      "answer": "executor, maker",
      "ru": "Исполнитель"
    },
    {
      "id": "382",
      "question": "raueta",
      "answer": "to lapse ",
      "ru": "Истекать"
    },
    {
      "id": "383",
      "question": "päiväkoti",
      "answer": "day school ",
      "ru": "Детский сад"
    },
    {
      "id": "384",
      "question": " yksityinen",
      "answer": "private",
      "ru": "Частный"
    },
    {
      "id": "385",
      "question": "esiopetus",
      "answer": "preschool education",
      "ru": "Дошкольное образование"
    },
    {
      "id": "386",
      "question": "iltapäiväkerho",
      "answer": "after-school club",
      "ru": "Группа продлённого дня"
    },
    {
      "id": "387",
      "question": "varhaiskasvatus",
      "answer": "preschool education",
      "ru": "Раннее дошкольное образование"
    },
    {
      "id": "388",
      "question": "sijainen",
      "answer": "substitute ",
      "ru": "Заменитель"
    },
    {
      "id": "389",
      "question": "varavaate",
      "answer": "change of clothes",
      "ru": "Запасная одежда"
    },
    {
      "id": "390",
      "question": "sadevaate",
      "answer": "rainwear",
      "ru": "Дождевик"
    },
    {
      "id": "391",
      "question": "sadetakki",
      "answer": "raincoat ",
      "ru": "Плащ"
    },
    {
      "id": "392",
      "question": "kumisaappaat",
      "answer": "rubber boots",
      "ru": "Резиновые сапоги"
    },
    {
      "id": "393",
      "question": "ryhmä",
      "answer": "group",
      "ru": "Группа"
    },
    {
      "id": "394",
      "question": "ruokailu",
      "answer": "eating",
      "ru": "Приём пищи"
    },
    {
      "id": "395",
      "question": "päivälepo",
      "answer": "daily rest",
      "ru": "Дневной отдых"
    },
    {
      "id": "396",
      "question": "päiväunet",
      "answer": "afternoon nap",
      "ru": "Тихий час"
    },
    {
      "id": "397",
      "question": "piiri",
      "answer": "circle ",
      "ru": "Круг"
    },
    {
      "id": "398",
      "question": "askartelu",
      "answer": "hobby activity",
      "ru": "Поделки"
    },
    {
      "id": "399",
      "question": "leikki",
      "answer": "game of play ",
      "ru": "Игра"
    },
    {
      "id": "400",
      "question": "liukumäki",
      "answer": "playground slide",
      "ru": "Горка"
    },
    {
      "id": "401",
      "question": "kiipeilyteline",
      "answer": "climbing frame",
      "ru": "Лестница для лазания"
    },
    {
      "id": "402",
      "question": "keinu",
      "answer": "swing ",
      "ru": "Качели"
    },
    {
      "id": "403",
      "question": "tunnistautua",
      "answer": "to identificate",
      "ru": "Идентифицироваться"
    },
    {
      "id": "404",
      "question": "käyttäjätunnus",
      "answer": "user ID ",
      "ru": "Имя пользователя"
    },
    {
      "id": "405",
      "question": "salasana",
      "answer": "password",
      "ru": "Пароль"
    },
    {
      "id": "406",
      "question": "lomake",
      "answer": "form",
      "ru": "Бланк"
    },
    {
      "id": "407",
      "question": "perua",
      "answer": "to withdraw",
      "ru": "Отменить"
    },
    {
      "id": "408",
      "question": "peruttu",
      "answer": "cancelled ",
      "ru": "Отменён"
    },
    {
      "id": "409",
      "question": "heti",
      "answer": "immediately ",
      "ru": "Немедленно"
    },
    {
      "id": "410",
      "question": "aikaisintaan",
      "answer": "at the earliest",
      "ru": "Самое раннее"
    },
    {
      "id": "411",
      "question": "tällöin",
      "answer": "in that case ",
      "ru": "В таком случае"
    },
    {
      "id": "412",
      "question": "kiireellinen",
      "answer": "urgent ",
      "ru": "Срочный"
    },
    {
      "id": "413",
      "question": "pikainen",
      "answer": "quick ",
      "ru": "Быстрый"
    },
    {
      "id": "414",
      "question": "jättää",
      "answer": "to leave, to submit",
      "ru": "Оставлять"
    },
    {
      "id": "415",
      "question": "kaikkialla",
      "answer": "everywhere ",
      "ru": "Везде"
    },
    {
      "id": "416",
      "question": "sijaita",
      "answer": "be located ",
      "ru": "Находиться"
    },
    {
      "id": "417",
      "question": "vapautua",
      "answer": "to become free",
      "ru": "Освобождаться"
    },
    {
      "id": "418",
      "question": "vuodenvaihde",
      "answer": "turn of the year",
      "ru": "Смена года"
    },
    {
      "id": "419",
      "question": "huokaista",
      "answer": "to sigh, take a break",
      "ru": "Вздохнуть"
    },
    {
      "id": "420",
      "question": "huokaista helpotuksesta",
      "answer": "to breath a sign of relief",
      "ru": "Вздохнуть с облегчением"
    },
    {
      "id": "421",
      "question": "käydä ilmi",
      "answer": "to turn out",
      "ru": "Выясниться"
    },
    {
      "id": "422",
      "question": "laita",
      "answer": "an edge , side",
      "ru": "Край"
    },
    {
      "id": "423",
      "question": "sanomattakin on selvää",
      "answer": "it's clear without saying",
      "ru": "Само собой разумеется"
    },
    {
      "id": "424",
      "question": "kuljettaa",
      "answer": "to transport ",
      "ru": "Перевозить"
    },
    {
      "id": "425",
      "question": "jäädä huomaamatta",
      "answer": "to escape one's attention",
      "ru": "Остаться незамеченным"
    },
    {
      "id": "426",
      "question": "siirtää",
      "answer": "to move, shift,reschedule ",
      "ru": "Перемещать"
    },
    {
      "id": "427",
      "question": "sietää",
      "answer": "to endure ",
      "ru": "Терпеть"
    },
    {
      "id": "428",
      "question": "aamuvarhainen",
      "answer": "early morning",
      "ru": "Ранее утро"
    },
    {
      "id": "429",
      "question": "reppu",
      "answer": "backpack",
      "ru": "Рюкзак"
    },
    {
      "id": "430",
      "question": "kannettava tietokone",
      "answer": "portable computer ",
      "ru": "Ноутбук"
    },
    {
      "id": "431",
      "question": "uninalle",
      "answer": "bedtime toy ",
      "ru": "Игрушка для сна"
    },
    {
      "id": "432",
      "question": "lohduttomasti",
      "answer": "desolately , hopelessness",
      "ru": "Безутешно"
    },
    {
      "id": "433",
      "question": "voima",
      "answer": "power , force, strength",
      "ru": "Сила"
    },
    {
      "id": "434",
      "question": "epäonni",
      "answer": "misfortune",
      "ru": "Несчастье"
    },
    {
      "id": "435",
      "question": "liukastua",
      "answer": "to slip ",
      "ru": "Поскользнуться"
    },
    {
      "id": "436",
      "question": "murtua",
      "answer": "to break ",
      "ru": "Сломаться"
    },
    {
      "id": "437",
      "question": "kipsata",
      "answer": "to plaster ",
      "ru": "Накладывать гипс"
    },
    {
      "id": "438",
      "question": "neuvoton",
      "answer": "lost ",
      "ru": "Растерянный"
    },
    {
      "id": "439",
      "question": "huveta",
      "answer": "to diminish ",
      "ru": "Убывать"
    },
    {
      "id": "440",
      "question": "lähestyä",
      "answer": "to approach ",
      "ru": "Приближаться"
    },
    {
      "id": "441",
      "question": "toimiva",
      "answer": "active ",
      "ru": "Действующий"
    },
    {
      "id": "442",
      "question": "ratkaisu",
      "answer": "solution",
      "ru": "Решение"
    },
    {
      "id": "443",
      "question": "luopua",
      "answer": "abandon, give up",
      "ru": "Отказаться"
    },
    {
      "id": "444",
      "question": "ottaa vastaan",
      "answer": "to receive ",
      "ru": "Принимать"
    },
    {
      "id": "445",
      "question": "mennä sivu suun",
      "answer": "to miss out",
      "ru": "Упустить"
    },
    {
      "id": "446",
      "question": "olla kyse",
      "answer": "about ",
      "ru": "Быть о чём-то"
    },
    {
      "id": "447",
      "question": "selvitä",
      "answer": "to get over, get through, clarify",
      "ru": "Справиться"
    },
    {
      "id": "448",
      "question": "jotenkin",
      "answer": "somehow ",
      "ru": "Как-нибудь"
    },
    {
      "id": "449",
      "question": "ehdottaa",
      "answer": "to suggest ",
      "ru": "Предлагать"
    },
    {
      "id": "450",
      "question": "palkata",
      "answer": "to hire ",
      "ru": "Нанимать"
    },
    {
      "id": "451",
      "question": "tulot",
      "answer": "income",
      "ru": "Доход"
    },
    {
      "id": "452",
      "question": "ratketa",
      "answer": "to be solved",
      "ru": "Решаться"
    },
    {
      "id": "453",
      "question": "pölliä",
      "answer": "to steal , nick",
      "ru": "Стащить"
    },
    {
      "id": "454",
      "question": "kuori",
      "answer": "shell ",
      "ru": "Оболочка"
    },
    {
      "id": "455",
      "question": "peittää",
      "answer": "to cover ",
      "ru": "Покрывать"
    },
    {
      "id": "456",
      "question": "tunkea",
      "answer": "to crush, to force, cram, squeeze",
      "ru": "Втискивать"
    },
    {
      "id": "457",
      "question": "järjestys",
      "answer": "order",
      "ru": "Порядок"
    },
    {
      "id": "458",
      "question": "sääntö",
      "answer": "rule, regulation",
      "ru": "Правило"
    },
    {
      "id": "459",
      "question": "ohje",
      "answer": "guide",
      "ru": "Инструкция"
    },
    {
      "id": "460",
      "question": "määräys",
      "answer": "regulation ",
      "ru": "Постановление"
    },
    {
      "id": "461",
      "question": "pysäköintipaikka",
      "answer": "car park ",
      "ru": "Автостоянка"
    },
    {
      "id": "462",
      "question": "lunastaa",
      "answer": "to redeem ",
      "ru": "Выкупать"
    },
    {
      "id": "463",
      "question": "kunnioittaa",
      "answer": "to respect",
      "ru": "Уважать"
    },
    {
      "id": "464",
      "question": "hiljaisuus",
      "answer": "silence",
      "ru": "Тишина"
    },
    {
      "id": "465",
      "question": "tilapäinen",
      "answer": "occasional",
      "ru": "Временный"
    },
    {
      "id": "466",
      "question": "melu",
      "answer": "noise",
      "ru": "Шум"
    },
    {
      "id": "467",
      "question": "haitta",
      "answer": "drawback ",
      "ru": "Недостаток"
    },
    {
      "id": "468",
      "question": "huoneisto",
      "answer": "flat ",
      "ru": "Квартира"
    },
    {
      "id": "469",
      "question": "merkkipäivä",
      "answer": "special day ",
      "ru": "Знаменательный день"
    },
    {
      "id": "470",
      "question": "juhlinta",
      "answer": "celebration ",
      "ru": "Празднование"
    },
    {
      "id": "471",
      "question": "tiedottaa",
      "answer": "to inform, report",
      "ru": "Информировать"
    },
    {
      "id": "472",
      "question": "etukäteen",
      "answer": "beforehand",
      "ru": "Заранее"
    },
    {
      "id": "473",
      "question": "tuuletus",
      "answer": "ventilation ",
      "ru": "Вентиляция"
    },
    {
      "id": "474",
      "question": "tuulettaa",
      "answer": "to ventilate",
      "ru": "Проветривать"
    },
    {
      "id": "475",
      "question": "säilyttää",
      "answer": "to retain ",
      "ru": "Хранить"
    },
    {
      "id": "476",
      "question": "ullakko",
      "answer": "attic ",
      "ru": "Чердак"
    },
    {
      "id": "477",
      "question": "kielletty",
      "answer": "forbidden",
      "ru": "Запрещено"
    },
    {
      "id": "478",
      "question": "kieltää",
      "answer": "to forbid",
      "ru": "Запрещать"
    },
    {
      "id": "479",
      "question": "pelastus",
      "answer": "rescue ",
      "ru": "Спасение"
    },
    {
      "id": "480",
      "question": "pelastustie",
      "answer": "rescue road , emergency exit",
      "ru": "Аварийный выход"
    },
    {
      "id": "481",
      "question": "pelastaa",
      "answer": "to rescue ",
      "ru": "Спасать"
    },
    {
      "id": "482",
      "question": "sallia",
      "answer": "to allow, to permit ",
      "ru": "Разрешать"
    },
    {
      "id": "483",
      "question": "sallittu",
      "answer": "allowed ",
      "ru": "Разрешено"
    },
    {
      "id": "484",
      "question": "lyhytkestoinen",
      "answer": "volatile , short lived",
      "ru": "Недолговечный"
    },
    {
      "id": "485",
      "question": "lastata",
      "answer": "to load ",
      "ru": "Загружать"
    },
    {
      "id": "486",
      "question": "purkaa",
      "answer": "to dismantle",
      "ru": "Разбирать"
    },
    {
      "id": "487",
      "question": "kuivata",
      "answer": "to dry ",
      "ru": "Сушить"
    },
    {
      "id": "488",
      "question": "pesutupa",
      "answer": "laundry",
      "ru": "Прачечная"
    },
    {
      "id": "489",
      "question": "puhallin",
      "answer": "fan ",
      "ru": "Вентилятор"
    },
    {
      "id": "490",
      "question": "neuvo",
      "answer": "advice ",
      "ru": "Совет"
    },
    {
      "id": "491",
      "question": "säätää",
      "answer": "to adjust, regulate",
      "ru": "Регулировать"
    },
    {
      "id": "492",
      "question": "yhdistys",
      "answer": "association, society",
      "ru": "Ассоциация"
    },
    {
      "id": "493",
      "question": "yhteisöllisyys",
      "answer": "community ",
      "ru": "Общественность"
    },
    {
      "id": "494",
      "question": "tukea",
      "answer": "to support ",
      "ru": "Поддерживать"
    },
    {
      "id": "495",
      "question": "ensin",
      "answer": "first ",
      "ru": "Сначала"
    },
    {
      "id": "496",
      "question": "invalidi",
      "answer": "disabled ",
      "ru": "Инвалид"
    },
    {
      "id": "497",
      "question": "keino",
      "answer": "way",
      "ru": "Способ"
    },
    {
      "id": "498",
      "question": "kolo",
      "answer": "hole, groove, notch ",
      "ru": "Углубление"
    },
    {
      "id": "499",
      "question": "tasoittaa",
      "answer": "to level, flatten",
      "ru": "Выравнивать"
    },
    {
      "id": "500",
      "question": "levittää",
      "answer": "to spread",
      "ru": "Распространять"
    },
    {
      "id": "501",
      "question": "suutari",
      "answer": "shoemaker",
      "ru": "Сапожник"
    },
    {
      "id": "502",
      "question": "lojua",
      "answer": "to lay around ",
      "ru": "Валяться"
    },
    {
      "id": "503",
      "question": "palella",
      "answer": "to feel cold ",
      "ru": "Мёрзнуть"
    },
    {
      "id": "504",
      "question": "järkevä",
      "answer": "reasonable",
      "ru": "Разумный"
    },
    {
      "id": "505",
      "question": "myötä",
      "answer": "for, along, with",
      "ru": "Вместе с"
    },
    {
      "id": "506",
      "question": "uudenlainen",
      "answer": "novel, new kind",
      "ru": "Новый вид"
    },
    {
      "id": "507",
      "question": "asettua",
      "answer": "to settle down",
      "ru": "Обосноваться"
    },
    {
      "id": "508",
      "question": "vintti",
      "answer": "attic",
      "ru": "Мансарда"
    },
    {
      "id": "509",
      "question": "parisänky",
      "answer": "double bed ",
      "ru": "Двуспальная кровать"
    },
    {
      "id": "510",
      "question": "raskas",
      "answer": "heavy",
      "ru": "Тяжёлый"
    },
    {
      "id": "511",
      "question": "opastaa",
      "answer": "to guide",
      "ru": "Направлять"
    },
    {
      "id": "512",
      "question": "poistaa",
      "answer": "to remove, to delete",
      "ru": "Удалять"
    },
    {
      "id": "513",
      "question": "liikunta",
      "answer": "sports, exercise",
      "ru": "Физическая активность"
    },
    {
      "id": "514",
      "question": "ikionnellinen",
      "answer": "overjoyed",
      "ru": "Несказанно счастливый"
    },
    {
      "id": "515",
      "question": "päästä eroon",
      "answer": "to get rid of",
      "ru": "Избавиться"
    },
    {
      "id": "516",
      "question": "vaikeuttaa",
      "answer": "to hinder, complicate",
      "ru": "Затруднять"
    },
    {
      "id": "517",
      "question": "päivittäin",
      "answer": "daily ",
      "ru": "Ежедневно"
    },
    {
      "id": "518",
      "question": "niinpä",
      "answer": "you bet, indeed , so",
      "ru": "Именно так"
    },
    {
      "id": "519",
      "question": "kipsi",
      "answer": "plaster ",
      "ru": "Гипс"
    },
    {
      "id": "520",
      "question": "latino",
      "answer": "Latin American",
      "ru": "Латиноамериканец"
    },
    {
      "id": "521",
      "question": "tottua",
      "answer": "to get used to",
      "ru": "Привыкать"
    },
    {
      "id": "522",
      "question": "anoppi",
      "answer": "mother-in-law",
      "ru": "Свекровь/Тёща"
    },
    {
      "id": "523",
      "question": "häärätä",
      "answer": "bustle, hustle",
      "ru": "Суетиться"
    },
    {
      "id": "524",
      "question": "varoa",
      "answer": "look out ",
      "ru": "Остерегаться"
    },
    {
      "id": "525",
      "question": "muuten",
      "answer": "by the way  / otherwise",
      "ru": "Кстати"
    },
    {
      "id": "526",
      "question": "keksintö",
      "answer": "invention",
      "ru": "Изобретение"
    },
    {
      "id": "527",
      "question": "kätevä",
      "answer": "handy ",
      "ru": "Удобный"
    },
    {
      "id": "528",
      "question": "astiankuivauskaappi",
      "answer": "dish drying cupboard",
      "ru": "Сушильный шкаф для посуды"
    },
    {
      "id": "529",
      "question": "säästyä",
      "answer": "to be saved, be left over",
      "ru": "Сберегаться"
    },
    {
      "id": "530",
      "question": "tiski",
      "answer": "desk",
      "ru": "Стойка"
    },
    {
      "id": "531",
      "question": "kotirouva",
      "answer": "housewife",
      "ru": "Домохозяйка"
    },
    {
      "id": "532",
      "question": "lakana",
      "answer": "bedsheet ",
      "ru": "Простыня"
    },
    {
      "id": "533",
      "question": "nerokas",
      "answer": "ingenious , brilliant",
      "ru": "Гениальный"
    },
    {
      "id": "534",
      "question": "pussilakana",
      "answer": "blanket cover",
      "ru": "Пододеяльник"
    },
    {
      "id": "535",
      "question": "kulma",
      "answer": "corner, angle",
      "ru": "Угол"
    },
    {
      "id": "536",
      "question": "stressata",
      "answer": "to stress",
      "ru": "Нервничать"
    },
    {
      "id": "537",
      "question": "kaluste",
      "answer": "furniture, fitting",
      "ru": "Мебель"
    },
    {
      "id": "538",
      "question": "kotitalous",
      "answer": "household",
      "ru": "Домохозяйство"
    },
    {
      "id": "539",
      "question": "kokeilu",
      "answer": "experiment",
      "ru": "Эксперимент"
    },
    {
      "id": "540",
      "question": "valistus",
      "answer": "enlightenment",
      "ru": "Просвещение"
    },
    {
      "id": "541",
      "question": "toiminta",
      "answer": "activity, action",
      "ru": "Деятельность"
    },
    {
      "id": "542",
      "question": "tavoite",
      "answer": "goal ",
      "ru": "Цель"
    },
    {
      "id": "543",
      "question": "helpottaa",
      "answer": "to ease",
      "ru": "Облегчать"
    },
    {
      "id": "544",
      "question": "kekseliäisyys",
      "answer": "ingenuity ",
      "ru": "Изобретательность"
    },
    {
      "id": "545",
      "question": "lähtökohta",
      "answer": "basis , starting point",
      "ru": "Отправная точка"
    },
    {
      "id": "546",
      "question": "teline",
      "answer": "rack ",
      "ru": "Стойка"
    },
    {
      "id": "547",
      "question": "valua",
      "answer": "to run, flow",
      "ru": "Течь"
    },
    {
      "id": "548",
      "question": "sijoittaa",
      "answer": "to set, invest , place, locate",
      "ru": "Вкладывать"
    },
    {
      "id": "549",
      "question": "automaattinen",
      "answer": "automatic",
      "ru": "Автоматический"
    },
    {
      "id": "550",
      "question": "urakka",
      "answer": "work, task",
      "ru": "Объём работ"
    },
    {
      "id": "551",
      "question": "valmistaa",
      "answer": "to make, prepare",
      "ru": "Изготавливать"
    },
    {
      "id": "552",
      "question": "teollinen",
      "answer": "industrial",
      "ru": "Промышленный"
    },
    {
      "id": "553",
      "question": "etu",
      "answer": "advantage",
      "ru": "Преимущество"
    },
    {
      "id": "554",
      "question": "säilyä",
      "answer": "to remain",
      "ru": "Сохраняться"
    },
    {
      "id": "555",
      "question": "lähinnä",
      "answer": "mainly",
      "ru": "Главным образом"
    },
    {
      "id": "556",
      "question": "erikoisuus",
      "answer": "specialty",
      "ru": "Особенность"
    },
    {
      "id": "557",
      "question": "heijastin ",
      "answer": "reflector",
      "ru": "Отражатель"
    },
    {
      "id": "558",
      "question": "tuttu",
      "answer": "familiar ",
      "ru": "Знакомый"
    },
    {
      "id": "559",
      "question": "esine",
      "answer": "object, item ",
      "ru": "Предмет"
    },
    {
      "id": "560",
      "question": "valonsäde",
      "answer": "ray of light",
      "ru": "Луч света"
    },
    {
      "id": "561",
      "question": "heijastaa",
      "answer": "to reflect ",
      "ru": "Отражать"
    },
    {
      "id": "562",
      "question": "muovinpala",
      "answer": "piece of plastic ",
      "ru": "Кусок пластика"
    },
    {
      "id": "563",
      "question": "hiha",
      "answer": "sleeve",
      "ru": "Рукав"
    },
    {
      "id": "564",
      "question": "pala",
      "answer": "piece, slice ",
      "ru": "Кусок"
    },
    {
      "id": "565",
      "question": "harva",
      "answer": "few ",
      "ru": "Редкий"
    },
    {
      "id": "566",
      "question": "menettää",
      "answer": "to lose",
      "ru": "Терять"
    },
    {
      "id": "567",
      "question": "liikenneonnettomuus",
      "answer": "traffic accident",
      "ru": "Дорожно-транспортное происшествие"
    },
    {
      "id": "568",
      "question": "seuraus",
      "answer": "consequence",
      "ru": "Последствие"
    },
    {
      "id": "569",
      "question": "kolmio",
      "answer": "triangle",
      "ru": "Треугольник"
    },
    {
      "id": "570",
      "question": "hevoskärry",
      "answer": "horse cart ",
      "ru": "Конная телега"
    },
    {
      "id": "571",
      "question": "maantie",
      "answer": "highway ",
      "ru": "Шоссе"
    },
    {
      "id": "572",
      "question": "valmistus",
      "answer": "fabrication, production",
      "ru": "Производство"
    },
    {
      "id": "573",
      "question": "jalankulkija",
      "answer": "pedestrian ",
      "ru": "Пешеход"
    },
    {
      "id": "574",
      "question": "turvallisuus",
      "answer": "security, safety",
      "ru": "Безопасность"
    },
    {
      "id": "575",
      "question": "huolestunut",
      "answer": "concerned, worried",
      "ru": "Обеспокоенный"
    },
    {
      "id": "576",
      "question": "järjestö ",
      "answer": "organization ",
      "ru": "Организация"
    },
    {
      "id": "577",
      "question": "ajoneuvo",
      "answer": "vehicle",
      "ru": "Транспортное средство"
    },
    {
      "id": "578",
      "question": "puolikas",
      "answer": "half ",
      "ru": "Половина"
    },
    {
      "id": "579",
      "question": "koukku",
      "answer": "hook",
      "ru": "Крючок"
    },
    {
      "id": "580",
      "question": "ripustaa",
      "answer": "to hang, hook",
      "ru": "Вешать"
    },
    {
      "id": "581",
      "question": "tarkoittaa",
      "answer": "to mean",
      "ru": "Означать"
    },
    {
      "id": "582",
      "question": "vakiintua",
      "answer": "to be established",
      "ru": "Устанавливаться"
    },
    {
      "id": "583",
      "question": "turvallinen",
      "answer": "safe ",
      "ru": "Безопасный"
    },
    {
      "id": "584",
      "question": "käyttäytyä",
      "answer": "to behave",
      "ru": "Вести себя"
    },
    {
      "id": "585",
      "question": "säätää laki",
      "answer": "to pass a law ",
      "ru": "Принять закон"
    },
    {
      "id": "586",
      "question": "määrätä",
      "answer": "decide, set, order",
      "ru": "Назначать"
    },
    {
      "id": "587",
      "question": "pakollinen",
      "answer": "compulsory ",
      "ru": "Обязательный"
    },
    {
      "id": "588",
      "question": "lisätä",
      "answer": "to add, to increase",
      "ru": "Добавлять"
    },
    {
      "id": "589",
      "question": "hämärä",
      "answer": "dusk, gloomy",
      "ru": "Сумерки"
    },
    {
      "id": "590",
      "question": "havaita",
      "answer": "to detect, to notice",
      "ru": "Замечать"
    },
    {
      "id": "591",
      "question": "etäisyys ",
      "answer": "distance",
      "ru": "Расстояние"
    },
    {
      "id": "592",
      "question": "reagoida",
      "answer": "to react",
      "ru": "Реагировать"
    },
    {
      "id": "593",
      "question": "markkinoida",
      "answer": "to market",
      "ru": "Продвигать"
    },
    {
      "id": "594",
      "question": "myynti",
      "answer": "sales",
      "ru": "Продажи"
    },
    {
      "id": "595",
      "question": "hidastaa",
      "answer": "to slow down",
      "ru": "Замедлять"
    },
    {
      "id": "596",
      "question": "tuote",
      "answer": "product",
      "ru": "Продукт"
    },
    {
      "id": "597",
      "question": "ympäri maailmaa",
      "answer": "around the world",
      "ru": "По всему миру"
    },
    {
      "id": "598",
      "question": "makeutusaine",
      "answer": "sweetener",
      "ru": "Подсластитель"
    },
    {
      "id": "599",
      "question": "ravinto",
      "answer": "food, nutrition",
      "ru": "Питание"
    },
    {
      "id": "600",
      "question": "päinvastoin",
      "answer": "vice versa",
      "ru": "Наоборот"
    },
    {
      "id": "601",
      "question": "estää",
      "answer": "to prevent ",
      "ru": "Предотвращать"
    },
    {
      "id": "602",
      "question": "suojata",
      "answer": "to protect",
      "ru": "Защищать"
    },
    {
      "id": "603",
      "question": "vaikutus",
      "answer": "influence",
      "ru": "Влияние"
    },
    {
      "id": "604",
      "question": "korvike",
      "answer": "substitute",
      "ru": "Заменитель"
    },
    {
      "id": "605",
      "question": "yhdiste",
      "answer": "compound ",
      "ru": "Соединение"
    },
    {
      "id": "606",
      "question": "haitallinen",
      "answer": "harmful ",
      "ru": "Вредный"
    },
    {
      "id": "607",
      "question": "ominaisuus",
      "answer": "feature ",
      "ru": "Свойство"
    },
    {
      "id": "608",
      "question": "purukumi",
      "answer": "chewing gum",
      "ru": "Жевательная резинка"
    },
    {
      "id": "609",
      "question": "liitto",
      "answer": "union, alliance",
      "ru": "Союз"
    },
    {
      "id": "610",
      "question": "suositus",
      "answer": "recommendation",
      "ru": "Рекомендация"
    },
    {
      "id": "611",
      "question": "ehkäistä",
      "answer": "to defend, avoid",
      "ru": "Предотвращать"
    },
    {
      "id": "612",
      "question": "pinta",
      "answer": "surface",
      "ru": "Поверхность"
    },
    {
      "id": "613",
      "question": "ateria",
      "answer": "meal",
      "ru": "Еда"
    },
    {
      "id": "614",
      "question": "happo",
      "answer": "acid ",
      "ru": "Кислота"
    },
    {
      "id": "615",
      "question": "hyökkäys",
      "answer": "an attack",
      "ru": "Атака"
    },
    {
      "id": "616",
      "question": "happamuus",
      "answer": "sourness ",
      "ru": "Кислотность"
    },
    {
      "id": "617",
      "question": "olennainen",
      "answer": "essential, fundamental",
      "ru": "Существенный"
    },
    {
      "id": "618",
      "question": "makeuttaa",
      "answer": "to sweeten",
      "ru": "Подслащивать"
    },
    {
      "id": "619",
      "question": "pastilli",
      "answer": "pastille",
      "ru": "Пастилка"
    },
    {
      "id": "620",
      "question": "valikoima",
      "answer": "a selection, choice",
      "ru": "Ассортимент"
    },
    {
      "id": "621",
      "question": "varsin",
      "answer": "quite, especially",
      "ru": "Весьма"
    },
    {
      "id": "622",
      "question": "taikuri",
      "answer": "magician",
      "ru": "Фокусник"
    },
    {
      "id": "623",
      "question": "taikatemppu",
      "answer": "magic trick ",
      "ru": "Фокус"
    },
    {
      "id": "624",
      "question": "juoksija",
      "answer": "runner ",
      "ru": "Бегун"
    },
    {
      "id": "625",
      "question": "vauhti",
      "answer": "speed ",
      "ru": "Скорость"
    },
    {
      "id": "626",
      "question": "ryöstää",
      "answer": "to rob, steal",
      "ru": "Грабить"
    },
    {
      "id": "627",
      "question": "kultaseppä",
      "answer": "jeweller, goldsmith",
      "ru": "Ювелир"
    },
    {
      "id": "628",
      "question": "naamioida",
      "answer": "to disguise, mask",
      "ru": "Маскировать"
    },
    {
      "id": "629",
      "question": "ase",
      "answer": "weapon ",
      "ru": "Оружие"
    },
    {
      "id": "630",
      "question": "vitriini",
      "answer": "a display case",
      "ru": "Витрина"
    },
    {
      "id": "631",
      "question": "väkivalta",
      "answer": "violence",
      "ru": "Насилие"
    },
    {
      "id": "632",
      "question": "jäljennös",
      "answer": "replica",
      "ru": "Копия"
    },
    {
      "id": "633",
      "question": "epäilty",
      "answer": "suspect ",
      "ru": "Подозреваемый"
    },
    {
      "id": "634",
      "question": "hankala",
      "answer": "challenging ",
      "ru": "Трудный"
    },
    {
      "id": "635",
      "question": "toteuttaa",
      "answer": "to implement ",
      "ru": "Реализовывать"
    },
    {
      "id": "636",
      "question": "painottua",
      "answer": "to focus on",
      "ru": "Сосредотачиваться"
    },
    {
      "id": "637",
      "question": "innoissaan",
      "answer": "excited ",
      "ru": "Взволнованный"
    },
    {
      "id": "638",
      "question": "läjä",
      "answer": "stack, pile",
      "ru": "Куча"
    },
    {
      "id": "639",
      "question": "kohde",
      "answer": "destination ",
      "ru": "Объект"
    },
    {
      "id": "640",
      "question": "edustaa",
      "answer": "to represent ",
      "ru": "Представлять"
    },
    {
      "id": "641",
      "question": "aikakausi",
      "answer": "era",
      "ru": "Эпоха"
    },
    {
      "id": "642",
      "question": "arvoinen",
      "answer": "worth ",
      "ru": "Стоящий"
    },
    {
      "id": "643",
      "question": "puuttua",
      "answer": "to be missing , interfere",
      "ru": "Отсутствовать"
    },
    {
      "id": "644",
      "question": "tarina",
      "answer": "story ",
      "ru": "История"
    },
    {
      "id": "645",
      "question": "välähtää",
      "answer": "to flash",
      "ru": "Мелькнуть"
    },
    {
      "id": "646",
      "question": "tarkoitus",
      "answer": "idea, intention",
      "ru": "Намерение"
    },
    {
      "id": "647",
      "question": "heittää huulta",
      "answer": "to chat, joke",
      "ru": "Болтать"
    },
    {
      "id": "648",
      "question": "marmori",
      "answer": "marble ",
      "ru": "Мрамор"
    },
    {
      "id": "649",
      "question": "laatta",
      "answer": "plate",
      "ru": "Плитка"
    },
    {
      "id": "650",
      "question": "julkisivu",
      "answer": "front , facade",
      "ru": "Фасад"
    },
    {
      "id": "651",
      "question": "länsimainen",
      "answer": "western ",
      "ru": "Западный"
    },
    {
      "id": "652",
      "question": "sivistys",
      "answer": "civilization ",
      "ru": "Цивилизация"
    },
    {
      "id": "653",
      "question": "ylevä",
      "answer": "high, noble ",
      "ru": "Возвышенный"
    },
    {
      "id": "654",
      "question": "epäkäytännöllinen",
      "answer": "impractical ",
      "ru": "Непрактичный"
    },
    {
      "id": "655",
      "question": "kosteus",
      "answer": "humidity",
      "ru": "Влажность"
    },
    {
      "id": "656",
      "question": "perusteellisesti",
      "answer": "thoroughly, soundly",
      "ru": "Основательно"
    },
    {
      "id": "657",
      "question": "vahingoniloinen",
      "answer": "malicious ",
      "ru": "Злорадный"
    },
    {
      "id": "658",
      "question": "painaa",
      "answer": "to press",
      "ru": "Нажимать"
    },
    {
      "id": "659",
      "question": "vastaava",
      "answer": "corresponding , similar",
      "ru": "Соответствующий"
    },
    {
      "id": "660",
      "question": "kolmikko",
      "answer": "triad ",
      "ru": "Тройка"
    },
    {
      "id": "661",
      "question": "yksityiselämä",
      "answer": "private life",
      "ru": "Частная жизнь"
    },
    {
      "id": "662",
      "question": "ateljee",
      "answer": "studio, workshop ",
      "ru": "Мастерская"
    },
    {
      "id": "663",
      "question": "melkoinen",
      "answer": "considerable, rather",
      "ru": "Значительный"
    },
    {
      "id": "664",
      "question": "seurapiiri",
      "answer": "high society ",
      "ru": "Высшее общество"
    },
    {
      "id": "665",
      "question": "skandaali",
      "answer": "scandal ",
      "ru": "Скандал"
    },
    {
      "id": "666",
      "question": "tyypillinen",
      "answer": "typical ",
      "ru": "Типичный"
    },
    {
      "id": "667",
      "question": "ihailla",
      "answer": "to admire ",
      "ru": "Восхищаться"
    },
    {
      "id": "668",
      "question": "piirre",
      "answer": "feature ",
      "ru": "Черта"
    },
    {
      "id": "669",
      "question": "korostaa",
      "answer": "to emphasize",
      "ru": "Подчёркивать"
    },
    {
      "id": "670",
      "question": "inspiraatio",
      "answer": "inspiration",
      "ru": "Вдохновение"
    },
    {
      "id": "671",
      "question": "lähde",
      "answer": "source ",
      "ru": "Источник"
    },
    {
      "id": "672",
      "question": "tyylisuunta",
      "answer": "style ",
      "ru": "Стиль"
    },
    {
      "id": "673",
      "question": "luoda",
      "answer": "to create",
      "ru": "Создавать"
    },
    {
      "id": "674",
      "question": "edustaja",
      "answer": "representative ",
      "ru": "Представитель"
    },
    {
      "id": "675",
      "question": "pääosin",
      "answer": "mainly ",
      "ru": "В основном"
    },
    {
      "id": "676",
      "question": "yksityiskohta",
      "answer": "detail",
      "ru": "Деталь"
    },
    {
      "id": "677",
      "question": "torni",
      "answer": "tower",
      "ru": "Башня"
    },
    {
      "id": "678",
      "question": "koriste",
      "answer": "decoration, ornament",
      "ru": "Украшение"
    },
    {
      "id": "679",
      "question": "aihe",
      "answer": "topic ",
      "ru": "Тема"
    },
    {
      "id": "680",
      "question": "käpy",
      "answer": "cone",
      "ru": "Шишка"
    },
    {
      "id": "681",
      "question": "oksa",
      "answer": "branch",
      "ru": "Ветка"
    },
    {
      "id": "682",
      "question": "sisätila",
      "answer": "interior ",
      "ru": "Внутреннее пространство"
    },
    {
      "id": "683",
      "question": "luonne",
      "answer": "nature, character",
      "ru": "Характер"
    },
    {
      "id": "684",
      "question": "halli",
      "answer": "hall ",
      "ru": "Зал"
    },
    {
      "id": "685",
      "question": "lienee",
      "answer": "will",
      "ru": "Вероятно"
    },
    {
      "id": "686",
      "question": "ura",
      "answer": "career ",
      "ru": "Карьера"
    },
    {
      "id": "687",
      "question": "lahjakas ",
      "answer": "gifted",
      "ru": "Одарённый"
    },
    {
      "id": "688",
      "question": "muotoilija",
      "answer": "designer, stylist it",
      "ru": "Дизайнер"
    },
    {
      "id": "689",
      "question": "merkitys",
      "answer": "significance",
      "ru": "Значение"
    },
    {
      "id": "690",
      "question": "välinen",
      "answer": "between",
      "ru": "Между"
    },
    {
      "id": "691",
      "question": "harmonia",
      "answer": "harmony ",
      "ru": "Гармония"
    },
    {
      "id": "692",
      "question": "muoto",
      "answer": "form, format",
      "ru": "Форма"
    },
    {
      "id": "693",
      "question": "inhimillinen",
      "answer": "humane",
      "ru": "Человеческий"
    },
    {
      "id": "694",
      "question": "mittakaava",
      "answer": "scale ",
      "ru": "Масштаб"
    },
    {
      "id": "695",
      "question": "kongressi ",
      "answer": "congress",
      "ru": "Конгресс"
    },
    {
      "id": "696",
      "question": "myöhäinen",
      "answer": "late",
      "ru": "Поздний"
    },
    {
      "id": "697",
      "question": "vaihe",
      "answer": "stage, period, phase",
      "ru": "Этап"
    },
    {
      "id": "698",
      "question": "valaisin",
      "answer": "light, lamp ",
      "ru": "Светильник"
    },
    {
      "id": "699",
      "question": "innoittaa",
      "answer": "to inspire",
      "ru": "Вдохновлять"
    },
    {
      "id": "700",
      "question": "vuorokausi",
      "answer": "day and night (24 hours)",
      "ru": "Сутки"
    },
    {
      "id": "701",
      "question": "valaistus",
      "answer": "lit, illuminated",
      "ru": "Освещение"
    },
    {
      "id": "702",
      "question": "kokemus",
      "answer": "experience, knowledge",
      "ru": "Опыт"
    },
    {
      "id": "703",
      "question": "monumentaalinen",
      "answer": "monumental",
      "ru": "Монументальный"
    },
    {
      "id": "704",
      "question": "vastustus",
      "answer": "resistance",
      "ru": "Сопротивление"
    },
    {
      "id": "705",
      "question": "ennakkoon",
      "answer": "in advance ",
      "ru": "Заранее"
    },
    {
      "id": "706",
      "question": "vastustaa",
      "answer": "to fight, be oppose to",
      "ru": "Противостоять"
    },
    {
      "id": "707",
      "question": "kaupunkikuva",
      "answer": "cityscape",
      "ru": "Городской пейзаж"
    },
    {
      "id": "708",
      "question": "houkutella",
      "answer": "to entice, to lure",
      "ru": "Завлекать"
    },
    {
      "id": "709",
      "question": "skeittaaja",
      "answer": "skateboarder ",
      "ru": "Скейтбордист"
    },
    {
      "id": "710",
      "question": "palvoa",
      "answer": "to adore, worship",
      "ru": "Обожать"
    },
    {
      "id": "711",
      "question": "säveltää",
      "answer": "to compose ",
      "ru": "Сочинять"
    },
    {
      "id": "712",
      "question": "nurmikko",
      "answer": "lawn ",
      "ru": "Газон"
    },
    {
      "id": "713",
      "question": "kanava",
      "answer": "canal",
      "ru": "Канал"
    },
    {
      "id": "714",
      "question": "lakkauttaa",
      "answer": "to discontinue",
      "ru": "Упразднять"
    },
    {
      "id": "715",
      "question": "ihailija",
      "answer": "fan ",
      "ru": "Поклонник"
    },
    {
      "id": "716",
      "question": "huolestua",
      "answer": "to worry ",
      "ru": "Беспокоиться"
    },
    {
      "id": "717",
      "question": "haaveilla",
      "answer": "to daydream ",
      "ru": "Мечтать"
    },
    {
      "id": "718",
      "question": "rasia",
      "answer": "box",
      "ru": "Коробка"
    },
    {
      "id": "719",
      "question": "harkita",
      "answer": "to consider",
      "ru": "Рассматривать"
    },
    {
      "id": "720",
      "question": "nössö",
      "answer": "wimp ",
      "ru": "Тряпка"
    },
    {
      "id": "721",
      "question": "murehtia",
      "answer": "to worry, regret",
      "ru": "Горевать"
    },
    {
      "id": "722",
      "question": "kilpikonna",
      "answer": "turtle",
      "ru": "Черепаха"
    },
    {
      "id": "723",
      "question": "ulkoiluttaa",
      "answer": "to walk",
      "ru": "Выгуливать"
    },
    {
      "id": "724",
      "question": "huomio",
      "answer": "attention",
      "ru": "Внимание"
    },
    {
      "id": "725",
      "question": "livistää",
      "answer": "to run away",
      "ru": "Удирать"
    },
    {
      "id": "726",
      "question": "karkulainen",
      "answer": "fugitive ",
      "ru": "Беглец"
    },
    {
      "id": "727",
      "question": "etsintä",
      "answer": "search, quest",
      "ru": "Поиск"
    },
    {
      "id": "728",
      "question": "hävitä",
      "answer": "to disappear ",
      "ru": "Исчезать"
    },
    {
      "id": "729",
      "question": "matelija",
      "answer": "reptile",
      "ru": "Рептилия"
    },
    {
      "id": "730",
      "question": "pinkoa",
      "answer": "to run, dash",
      "ru": "Мчаться"
    },
    {
      "id": "731",
      "question": "kokea",
      "answer": "to experience ",
      "ru": "Испытывать"
    },
    {
      "id": "732",
      "question": "kököttää",
      "answer": "to stay put",
      "ru": "Сидеть на месте"
    },
    {
      "id": "733",
      "question": "välittömästi",
      "answer": "immediately ",
      "ru": "Немедленно"
    },
    {
      "id": "734",
      "question": "omistaja",
      "answer": "owner",
      "ru": "Владелец"
    },
    {
      "id": "735",
      "question": "vaikuttaa",
      "answer": "to influence, seems",
      "ru": "Влиять"
    },
    {
      "id": "736",
      "question": "selviytyä",
      "answer": "to survive",
      "ru": "Выживать"
    },
    {
      "id": "737",
      "question": "pystyä",
      "answer": "to be able to, can",
      "ru": "Быть способным"
    },
    {
      "id": "738",
      "question": "sitkeä",
      "answer": "tough",
      "ru": "Стойкий"
    },
    {
      "id": "739",
      "question": "otus",
      "answer": "creature, beast",
      "ru": "Существо"
    },
    {
      "id": "740",
      "question": "julkisuuden henkilö",
      "answer": "celebrity ",
      "ru": "Знаменитость"
    },
    {
      "id": "741",
      "question": "vahingossa",
      "answer": "accidentally",
      "ru": "Случайно"
    },
    {
      "id": "742",
      "question": "mahtaa",
      "answer": "probably",
      "ru": "Вероятно"
    },
    {
      "id": "743",
      "question": "kuulemma",
      "answer": "hearsay",
      "ru": "Понаслышке"
    },
    {
      "id": "744",
      "question": "mahdollinen",
      "answer": "possible",
      "ru": "Возможный"
    },
    {
      "id": "745",
      "question": "pitää huolta",
      "answer": "to look after",
      "ru": "Заботиться"
    },
    {
      "id": "746",
      "question": "tyyppi",
      "answer": "type ",
      "ru": "Тип"
    },
    {
      "id": "747",
      "question": "tuskin",
      "answer": "hardly ",
      "ru": "Едва"
    },
    {
      "id": "748",
      "question": "parka",
      "answer": "pitiful ",
      "ru": "Бедняга"
    },
    {
      "id": "749",
      "question": "joka tapauksessa",
      "answer": "in any case ",
      "ru": "В любом случае"
    },
    {
      "id": "750",
      "question": "hyvin toimittu",
      "answer": "well done ",
      "ru": "Хорошо сделано"
    },
    {
      "id": "751",
      "question": "maanjäristys",
      "answer": "earthquake",
      "ru": "Землетрясение"
    },
    {
      "id": "752",
      "question": "häämatka",
      "answer": "honeymoon ",
      "ru": "Свадебное путешествие"
    },
    {
      "id": "753",
      "question": "kadottaa",
      "answer": "to lose",
      "ru": "Потерять"
    },
    {
      "id": "754",
      "question": "yhteydessä",
      "answer": "in touch , in connection with",
      "ru": "В связи"
    },
    {
      "id": "755",
      "question": "lounastaa",
      "answer": "to have lunch ",
      "ru": "Обедать"
    },
    {
      "id": "756",
      "question": "paikallinen",
      "answer": "local ",
      "ru": "Местный"
    },
    {
      "id": "757",
      "question": "ihmisjoukko",
      "answer": "crowd ",
      "ru": "Толпа"
    },
    {
      "id": "758",
      "question": "kaaos",
      "answer": "chaos",
      "ru": "Хаос"
    },
    {
      "id": "759",
      "question": "toki",
      "answer": "of course",
      "ru": "Конечно"
    },
    {
      "id": "760",
      "question": "kieltämättä",
      "answer": "without doubt",
      "ru": "Несомненно"
    },
    {
      "id": "761",
      "question": "aika lailla",
      "answer": "quite a bit",
      "ru": "Довольно много"
    },
    {
      "id": "762",
      "question": "rankkasade",
      "answer": "downpour ",
      "ru": "Ливень"
    },
    {
      "id": "763",
      "question": "ilmeisesti",
      "answer": "apparently, evidently",
      "ru": "По-видимому"
    },
    {
      "id": "764",
      "question": "osua",
      "answer": "hit, reach",
      "ru": "Попадать"
    },
    {
      "id": "765",
      "question": "vaurio",
      "answer": "damage ",
      "ru": "Повреждение"
    },
    {
      "id": "766",
      "question": "muistikortti",
      "answer": "memory card ",
      "ru": "Карта памяти"
    },
    {
      "id": "767",
      "question": "sisältää",
      "answer": "to include, to contain",
      "ru": "Содержать"
    },
    {
      "id": "768",
      "question": "tuottaa",
      "answer": "to produce ",
      "ru": "Производить"
    },
    {
      "id": "769",
      "question": "virnistää",
      "answer": "to grin ",
      "ru": "Ухмыляться"
    },
    {
      "id": "770",
      "question": "ryöstö",
      "answer": "robbery ",
      "ru": "Ограбление"
    },
    {
      "id": "771",
      "question": "epäonnistunut",
      "answer": "failed, unsuccessful",
      "ru": "Неудачный"
    },
    {
      "id": "772",
      "question": "uhata",
      "answer": "to threaten",
      "ru": "Угрожать"
    },
    {
      "id": "773",
      "question": "nolo",
      "answer": "embarrassed",
      "ru": "Смущённый"
    },
    {
      "id": "774",
      "question": "saalis",
      "answer": "prey ",
      "ru": "Добыча"
    },
    {
      "id": "775",
      "question": "sen enempää",
      "answer": "more than that",
      "ru": "Больше того"
    },
    {
      "id": "776",
      "question": "kori",
      "answer": "basket ",
      "ru": "Корзина"
    },
    {
      "id": "777",
      "question": "tempaista",
      "answer": "wrench ",
      "ru": "Вырвать"
    },
    {
      "id": "778",
      "question": "pelästyä",
      "answer": "to be scared ",
      "ru": "Испугаться"
    },
    {
      "id": "779",
      "question": "juoru",
      "answer": "gossip ",
      "ru": "Слухи"
    },
    {
      "id": "780",
      "question": "näppäin",
      "answer": "key, button",
      "ru": "Клавиша"
    },
    {
      "id": "781",
      "question": "loppujen lopuksi",
      "answer": "after all",
      "ru": "В конце концов"
    },
    {
      "id": "782",
      "question": "pinkaista",
      "answer": "to sprint ",
      "ru": "Рвануть"
    },
    {
      "id": "783",
      "question": "tatuointi",
      "answer": "tattoo ",
      "ru": "Татуировка"
    },
    {
      "id": "784",
      "question": "nahkatakki",
      "answer": "leather jacket",
      "ru": "Кожаная куртка"
    },
    {
      "id": "785",
      "question": "havainto",
      "answer": "observation",
      "ru": "Наблюдение"
    },
    {
      "id": "786",
      "question": "kohu",
      "answer": "sensation, scandal",
      "ru": "Шумиха"
    },
    {
      "id": "787",
      "question": "rattijuopumus",
      "answer": "drunk driving",
      "ru": "Вождение в нетрезвом виде"
    },
    {
      "id": "788",
      "question": "julkisuus",
      "answer": "publicity ",
      "ru": "Публичность"
    },
    {
      "id": "789",
      "question": "esiintyä",
      "answer": "to perform ",
      "ru": "Выступать"
    },
    {
      "id": "790",
      "question": "estradi",
      "answer": "stage ",
      "ru": "Эстрада"
    },
    {
      "id": "791",
      "question": "päihtynyt",
      "answer": "intoxicated ",
      "ru": "Опьянённый"
    },
    {
      "id": "792",
      "question": "railakas",
      "answer": "hilarious",
      "ru": "Бурный"
    },
    {
      "id": "793",
      "question": "risteys ",
      "answer": "intersection",
      "ru": "Перекрёсток"
    },
    {
      "id": "794",
      "question": "puhaltaa",
      "answer": "to blow",
      "ru": "Дуть"
    },
    {
      "id": "795",
      "question": "alkometri",
      "answer": "breathalyzer",
      "ru": "Алкотестер"
    },
    {
      "id": "796",
      "question": "törkeä",
      "answer": "aggravated ",
      "ru": "Грубый"
    },
    {
      "id": "797",
      "question": "pidättää",
      "answer": "suspend, place under arrest",
      "ru": "Задерживать"
    },
    {
      "id": "798",
      "question": "vaarantaa",
      "answer": "to risk, endanger ",
      "ru": "Подвергать опасности"
    },
    {
      "id": "799",
      "question": "tunteikas",
      "answer": "emotional ",
      "ru": "Эмоциональный"
    },
    {
      "id": "800",
      "question": "anteeksipyyntö",
      "answer": "apology ",
      "ru": "Извинение"
    },
    {
      "id": "801",
      "question": "ääretön",
      "answer": "indefinite ",
      "ru": "Бесконечный"
    },
    {
      "id": "802",
      "question": "häpeissään",
      "answer": "ashamed ",
      "ru": "Пристыженный"
    },
    {
      "id": "803",
      "question": "suoraan sanottuna",
      "answer": "frankly ",
      "ru": "Прямо говоря"
    },
    {
      "id": "804",
      "question": "teko",
      "answer": "act , deed, achievement",
      "ru": "Поступок"
    },
    {
      "id": "805",
      "question": "katua",
      "answer": "to regret",
      "ru": "Сожалеть"
    },
    {
      "id": "806",
      "question": "tapaus",
      "answer": "case, incident ",
      "ru": "Случай"
    },
    {
      "id": "807",
      "question": "todennäköisesti",
      "answer": "probably",
      "ru": "Вероятно"
    },
    {
      "id": "808",
      "question": "ehdollinen",
      "answer": "conditional ",
      "ru": "Условный"
    },
    {
      "id": "809",
      "question": "vankeus",
      "answer": "imprisonment",
      "ru": "Заключение"
    },
    {
      "id": "810",
      "question": "tuomio",
      "answer": "sentence, judgement",
      "ru": "Приговор"
    },
    {
      "id": "811",
      "question": "sakko",
      "answer": "penalty ",
      "ru": "Штраф"
    },
    {
      "id": "812",
      "question": "rangaista",
      "answer": "to punish ",
      "ru": "Наказывать"
    },
    {
      "id": "813",
      "question": "rikos",
      "answer": "offense, crime ",
      "ru": "Преступление"
    },
    {
      "id": "814",
      "question": "väliaikainen",
      "answer": "temporary",
      "ru": "Временный"
    },
    {
      "id": "815",
      "question": "kielto",
      "answer": "prohibition",
      "ru": "Запрет"
    },
    {
      "id": "816",
      "question": "luonnonkatastrofi",
      "answer": "natural disaster",
      "ru": "Природная катастрофа"
    },
    {
      "id": "817",
      "question": "kuivuus",
      "answer": "drought",
      "ru": "Засуха"
    },
    {
      "id": "818",
      "question": "metsäpalo ",
      "answer": "forest fire",
      "ru": "Лесной пожар"
    },
    {
      "id": "819",
      "question": "hirmumyrsky",
      "answer": "hurricane",
      "ru": "Ураган"
    },
    {
      "id": "820",
      "question": "pyörremyrsky",
      "answer": "cyclone ",
      "ru": "Циклон"
    },
    {
      "id": "821",
      "question": "tulva",
      "answer": "flood ",
      "ru": "Наводнение"
    },
    {
      "id": "822",
      "question": "hyökyaalto ",
      "answer": "tsunami",
      "ru": "Цунами"
    },
    {
      "id": "823",
      "question": "lumivyöry",
      "answer": "avalanche",
      "ru": "Лавина"
    },
    {
      "id": "824",
      "question": "tulivuorenpurkaus",
      "answer": "volcanic eruption",
      "ru": "Извержение вулкана"
    },
    {
      "id": "825",
      "question": "vahinko",
      "answer": "damage, harm",
      "ru": "Ущерб"
    },
    {
      "id": "826",
      "question": "vahingoittaa",
      "answer": "to damage",
      "ru": "Повреждать"
    },
    {
      "id": "827",
      "question": "aineellinen",
      "answer": "tangible, physical ",
      "ru": "Материальный"
    },
    {
      "id": "828",
      "question": "henkilövahinko",
      "answer": "bodily injury ",
      "ru": "Телесный вред"
    },
    {
      "id": "829",
      "question": "kuolonuhri",
      "answer": "fatality",
      "ru": "Погибший"
    },
    {
      "id": "830",
      "question": "loukkaantua",
      "answer": "to be hurt, injured",
      "ru": "Получать травму"
    },
    {
      "id": "831",
      "question": "evakuoida",
      "answer": "to evacuate",
      "ru": "Эвакуировать"
    },
    {
      "id": "832",
      "question": "hätätila",
      "answer": "state of emergency",
      "ru": "Чрезвычайное положение"
    },
    {
      "id": "833",
      "question": "uhka",
      "answer": "threat",
      "ru": "Угроза"
    },
    {
      "id": "834",
      "question": "tuho",
      "answer": "destruction",
      "ru": "Разрушение"
    },
    {
      "id": "835",
      "question": "tuhota",
      "answer": "to destroy",
      "ru": "Уничтожать"
    },
    {
      "id": "836",
      "question": "tuhoutua",
      "answer": "to be destroyed",
      "ru": "Быть уничтоженным"
    },
    {
      "id": "837",
      "question": "onnettomuus",
      "answer": "accident ",
      "ru": "Несчастный случай"
    },
    {
      "id": "838",
      "question": "turma",
      "answer": "accident ",
      "ru": "Авария"
    },
    {
      "id": "839",
      "question": "tulipalo",
      "answer": "fire ",
      "ru": "Пожар"
    },
    {
      "id": "840",
      "question": "kolari",
      "answer": "crash, collision ",
      "ru": "Авария"
    },
    {
      "id": "841",
      "question": "haaksirikko",
      "answer": "shipwreck ",
      "ru": "Кораблекрушение"
    },
    {
      "id": "842",
      "question": "räjähdys",
      "answer": "explosion",
      "ru": "Взрыв"
    },
    {
      "id": "843",
      "question": "terrori-isku",
      "answer": "terrorist strike",
      "ru": "Теракт"
    },
    {
      "id": "844",
      "question": "rikollinen",
      "answer": "criminal ",
      "ru": "Преступник"
    },
    {
      "id": "845",
      "question": "uhri",
      "answer": "a victim",
      "ru": "Жертва"
    },
    {
      "id": "846",
      "question": "murto",
      "answer": "breaking in ",
      "ru": "Взлом"
    },
    {
      "id": "847",
      "question": "petos",
      "answer": "betrayal",
      "ru": "Обман"
    },
    {
      "id": "848",
      "question": "huumausaine",
      "answer": "drug",
      "ru": "Наркотик"
    },
    {
      "id": "849",
      "question": "salakuljetus",
      "answer": "smuggling",
      "ru": "Контрабанда"
    },
    {
      "id": "850",
      "question": "pahoinpitely",
      "answer": "abuse",
      "ru": "Избиение"
    },
    {
      "id": "851",
      "question": "ihmiskauppa",
      "answer": "human trafficking",
      "ru": "Торговля людьми"
    },
    {
      "id": "852",
      "question": "tappo",
      "answer": "killing ",
      "ru": "Убийство"
    },
    {
      "id": "853",
      "question": "murha",
      "answer": "murder",
      "ru": "Убийство"
    },
    {
      "id": "854",
      "question": "liikennerikkomus",
      "answer": "traffic violation",
      "ru": "Нарушение ПДД"
    },
    {
      "id": "855",
      "question": "ylinopeus",
      "answer": "speeding ",
      "ru": "Превышение скорости"
    },
    {
      "id": "856",
      "question": "tutkia",
      "answer": "to examine",
      "ru": "Исследовать"
    },
    {
      "id": "857",
      "question": "kuulustella",
      "answer": "question ",
      "ru": "Допрашивать"
    },
    {
      "id": "858",
      "question": "todistaja",
      "answer": "witness",
      "ru": "Свидетель"
    },
    {
      "id": "859",
      "question": "silminnäkijä",
      "answer": "eyewitness",
      "ru": "Очевидец"
    },
    {
      "id": "860",
      "question": "asianajaja ",
      "answer": "lawyer ",
      "ru": "Адвокат"
    },
    {
      "id": "861",
      "question": "tuomari",
      "answer": "judge",
      "ru": "Судья"
    },
    {
      "id": "862",
      "question": "oikeudenkäynti",
      "answer": "trial ",
      "ru": "Судебный процесс"
    },
    {
      "id": "863",
      "question": "syyttää",
      "answer": "to blame",
      "ru": "Обвинять"
    },
    {
      "id": "864",
      "question": "syytetty",
      "answer": "accused ",
      "ru": "Обвиняемый"
    },
    {
      "id": "865",
      "question": "syyllinen",
      "answer": "guilty ",
      "ru": "Виновный"
    },
    {
      "id": "866",
      "question": "syytön",
      "answer": "innocent",
      "ru": "Невиновный"
    },
    {
      "id": "867",
      "question": "ehdonalainen",
      "answer": "parole",
      "ru": "Условный срок"
    },
    {
      "id": "868",
      "question": "elinkautinen",
      "answer": "life sentence ",
      "ru": "Пожизненное заключение"
    },
    {
      "id": "869",
      "question": "kuolemanrangaistus",
      "answer": "death penalty",
      "ru": "Смертная казнь"
    },
    {
      "id": "870",
      "question": "vankila",
      "answer": "prison",
      "ru": "Тюрьма"
    },
    {
      "id": "871",
      "question": "putka",
      "answer": "jail ",
      "ru": "Камера"
    },
    {
      "id": "872",
      "question": "väittää",
      "answer": "to claim ",
      "ru": "Утверждать"
    },
    {
      "id": "873",
      "question": "koputtaa",
      "answer": "to knock ",
      "ru": "Стучать"
    },
    {
      "id": "874",
      "question": "mutista",
      "answer": "mumble ",
      "ru": "Бормотать"
    },
    {
      "id": "875",
      "question": "raukka",
      "answer": "poor ",
      "ru": "Бедняга"
    },
    {
      "id": "876",
      "question": "tulvia",
      "answer": "to flood ",
      "ru": "Наводнять"
    },
    {
      "id": "877",
      "question": "käry",
      "answer": "smoky smell",
      "ru": "Запах дыма"
    },
    {
      "id": "878",
      "question": "meteli",
      "answer": "noise ",
      "ru": "Шум"
    },
    {
      "id": "879",
      "question": "mainita",
      "answer": "to mention ",
      "ru": "Упоминать"
    },
    {
      "id": "880",
      "question": "kuiskata",
      "answer": "to whisper",
      "ru": "Шептать"
    },
    {
      "id": "881",
      "question": "huutaa",
      "answer": "to shout; to yell to think (about, over)",
      "ru": "Кричать"
    },
    {
      "id": "882",
      "question": "tuntea",
      "answer": "to feel; to know",
      "ru": "Чувствовать"
    },
    {
      "id": "883",
      "question": "lööppi",
      "answer": "headline ",
      "ru": "Заголовок"
    },
    {
      "id": "884",
      "question": "viihde",
      "answer": "entertainment",
      "ru": "Развлечение"
    },
    {
      "id": "885",
      "question": "perä",
      "answer": "after, stern",
      "ru": "Корма"
    },
    {
      "id": "886",
      "question": "vilpitön",
      "answer": "frank ",
      "ru": "Искренний"
    },
    {
      "id": "887",
      "question": "lievä",
      "answer": "slight",
      "ru": "Лёгкий"
    },
    {
      "id": "888",
      "question": "ehdoton",
      "answer": "absolute",
      "ru": "Абсолютный"
    },
    {
      "id": "889",
      "question": "orja",
      "answer": "slave",
      "ru": "Раб"
    },
    {
      "id": "890",
      "question": "sinnikäs",
      "answer": "steadfast, persistent",
      "ru": "Настойчивый"
    },
    {
      "id": "891",
      "question": "oitis",
      "answer": "at once ",
      "ru": "Немедленно"
    },
    {
      "id": "892",
      "question": "kääre",
      "answer": "wrapping",
      "ru": "Обёртка"
    },
    {
      "id": "893",
      "question": "reisi",
      "answer": "thigh ",
      "ru": "Бедро"
    },
    {
      "id": "894",
      "question": "kätkö",
      "answer": "hiding place",
      "ru": "Тайник"
    },
    {
      "id": "895",
      "question": "puhdistaa",
      "answer": "to clean ",
      "ru": "Очищать"
    },
    {
      "id": "896",
      "question": "hormi",
      "answer": "flue ",
      "ru": "Дымоход"
    },
    {
      "id": "897",
      "question": "peräisin",
      "answer": "coming from, origin",
      "ru": "Происходить из"
    },
    {
      "id": "898",
      "question": "hupaisa",
      "answer": "funny ",
      "ru": "Забавный"
    },
    {
      "id": "899",
      "question": "pirteä",
      "answer": "perky",
      "ru": "Бодрый"
    },
    {
      "id": "900",
      "question": "turhaan",
      "answer": "in vain ",
      "ru": "Напрасно"
    },
    {
      "id": "901",
      "question": "kärsiä",
      "answer": "to suffer",
      "ru": "Страдать"
    },
    {
      "id": "902",
      "question": "tavallaan",
      "answer": "kind of, in a way",
      "ru": "Своего рода"
    },
    {
      "id": "903",
      "question": "nukkua pois",
      "answer": "pass away",
      "ru": "Скончаться"
    },
    {
      "id": "904",
      "question": "sairastaa",
      "answer": "to be sick ",
      "ru": "Болеть"
    },
    {
      "id": "905",
      "question": "kaivaa esiin",
      "answer": "to unearth ",
      "ru": "Откопать"
    },
    {
      "id": "906",
      "question": "ratkaista",
      "answer": "to solve, to determine",
      "ru": "Решить"
    },
    {
      "id": "907",
      "question": "tervehtiä",
      "answer": "to greet",
      "ru": "Приветствовать"
    },
    {
      "id": "908",
      "question": "vakioasiakas",
      "answer": "regular customer",
      "ru": "Постоянный клиент"
    },
    {
      "id": "909",
      "question": "uppoutua",
      "answer": "to immerse in ",
      "ru": "Погружаться"
    },
    {
      "id": "910",
      "question": "herrasmies",
      "answer": "gentleman",
      "ru": "Джентльмен"
    },
    {
      "id": "911",
      "question": "parantaa",
      "answer": "to improve",
      "ru": "Улучшать"
    },
    {
      "id": "912",
      "question": "ryhti",
      "answer": "posture ",
      "ru": "Осанка"
    },
    {
      "id": "913",
      "question": "unelias",
      "answer": "sleepy",
      "ru": "Сонный"
    },
    {
      "id": "914",
      "question": "karismaattinen",
      "answer": "charismatic ",
      "ru": "Харизматичный"
    },
    {
      "id": "915",
      "question": "vapaaehtoinen",
      "answer": "volunteer ",
      "ru": "Доброволец"
    },
    {
      "id": "916",
      "question": "konkari",
      "answer": "old hand , experienced person",
      "ru": "Ветеран"
    },
    {
      "id": "917",
      "question": "puolivälissä",
      "answer": "in the middle of ",
      "ru": "В середине"
    },
    {
      "id": "918",
      "question": "edelleen",
      "answer": "still",
      "ru": "По-прежнему"
    },
    {
      "id": "919",
      "question": "satunnainen",
      "answer": "random ",
      "ru": "Случайный"
    },
    {
      "id": "920",
      "question": "kouluttaa",
      "answer": "to train, educate",
      "ru": "Обучать"
    },
    {
      "id": "921",
      "question": "ohjaus",
      "answer": "guidance ",
      "ru": "Руководство"
    },
    {
      "id": "922",
      "question": "kulua",
      "answer": "to pass (time), to wear out ",
      "ru": "Проходить"
    },
    {
      "id": "923",
      "question": "mahtua",
      "answer": "to fit ",
      "ru": "Вмещаться"
    },
    {
      "id": "924",
      "question": "arvella",
      "answer": "believe, suppose, think",
      "ru": "Предполагать"
    },
    {
      "id": "925",
      "question": "suhtautua",
      "answer": "to concern, to relate to",
      "ru": "Относиться"
    },
    {
      "id": "926",
      "question": "keskiluokkainen",
      "answer": "middle class ",
      "ru": "Средний класс"
    },
    {
      "id": "927",
      "question": "kouluttautua",
      "answer": "to school, educate",
      "ru": "Получать образование"
    },
    {
      "id": "928",
      "question": "kauhu",
      "answer": "horror",
      "ru": "Ужас"
    },
    {
      "id": "929",
      "question": "avustus",
      "answer": "aid, contribution",
      "ru": "Помощь"
    },
    {
      "id": "930",
      "question": "seurustella",
      "answer": "to socialize",
      "ru": "Общаться"
    },
    {
      "id": "931",
      "question": "menehtyä",
      "answer": "to perish",
      "ru": "Погибать"
    },
    {
      "id": "932",
      "question": "jättää taakseen",
      "answer": "to leave behind ",
      "ru": "Оставить позади"
    },
    {
      "id": "933",
      "question": "leski",
      "answer": "widow ",
      "ru": "Вдова"
    },
    {
      "id": "934",
      "question": "ryhtyä saada kiinni",
      "answer": "to start, to proceed",
      "ru": "Начать"
    },
    {
      "id": "935",
      "question": "menetys",
      "answer": "loss ",
      "ru": "Потеря"
    },
    {
      "id": "936",
      "question": "rahtilaiva",
      "answer": "cargo ship ",
      "ru": "Грузовое судно"
    },
    {
      "id": "937",
      "question": "pohtia",
      "answer": "to ponder",
      "ru": "Обдумывать"
    },
    {
      "id": "938",
      "question": "alus",
      "answer": "ship (vessel) ",
      "ru": "Судно"
    },
    {
      "id": "939",
      "question": "onnistua",
      "answer": "to manage, succeed",
      "ru": "Успеть"
    },
    {
      "id": "940",
      "question": "saada kuulla",
      "answer": "to get to hear ",
      "ru": "Услышать"
    },
    {
      "id": "941",
      "question": "ilahtua",
      "answer": "to cheer up",
      "ru": "Обрадоваться"
    },
    {
      "id": "942",
      "question": "päähänpisto",
      "answer": "whim ",
      "ru": "Прихоть"
    },
    {
      "id": "943",
      "question": "pelkkä",
      "answer": "bare, mere ",
      "ru": "Просто"
    },
    {
      "id": "944",
      "question": "kokata",
      "answer": "to cook",
      "ru": "Готовить"
    },
    {
      "id": "945",
      "question": "pikemminkin",
      "answer": "on the contrary ",
      "ru": "Скорее"
    },
    {
      "id": "946",
      "question": "kuolema",
      "answer": "death ",
      "ru": "Смерть"
    },
    {
      "id": "947",
      "question": "seikkailu",
      "answer": "adventure ",
      "ru": "Приключение"
    },
    {
      "id": "948",
      "question": "vanhus",
      "answer": "old person",
      "ru": "Пожилой человек"
    },
    {
      "id": "949",
      "question": "aloite",
      "answer": "initiative ",
      "ru": "Инициатива"
    },
    {
      "id": "950",
      "question": "sisältö",
      "answer": "contents ",
      "ru": "Содержание"
    },
    {
      "id": "951",
      "question": "entinen",
      "answer": "former",
      "ru": "Бывший"
    },
    {
      "id": "952",
      "question": "intensiivinen",
      "answer": "intensive",
      "ru": "Интенсивный"
    },
    {
      "id": "953",
      "question": "itsetunto",
      "answer": "self-esteem, self belief",
      "ru": "Самооценка"
    },
    {
      "id": "954",
      "question": "äkkiä",
      "answer": "quickly, suddenly",
      "ru": "Быстро"
    },
    {
      "id": "955",
      "question": "muistella",
      "answer": "to remember, to recall",
      "ru": "Вспоминать"
    },
    {
      "id": "956",
      "question": "avioitua",
      "answer": "to get married",
      "ru": "Жениться"
    },
    {
      "id": "957",
      "question": "ryhtyä",
      "answer": "to start, to proceed ",
      "ru": "Начинать"
    },
    {
      "id": "958",
      "question": "hyväksyä",
      "answer": "to accept ",
      "ru": "Принимать"
    },
    {
      "id": "959",
      "question": "ei ikinä",
      "answer": "no way",
      "ru": "Ни за что"
    },
    {
      "id": "960",
      "question": "täyttää odotukset",
      "answer": "to fill the requirements",
      "ru": "Оправдать ожидания"
    },
    {
      "id": "961",
      "question": "pitää omana tietonaan",
      "answer": "to withhold ",
      "ru": "Держать при себе"
    },
    {
      "id": "962",
      "question": "kaksoset",
      "answer": "gemini ",
      "ru": "Близнецы"
    },
    {
      "id": "963",
      "question": "pudistella",
      "answer": "to shake",
      "ru": "Покачивать"
    },
    {
      "id": "964",
      "question": "hulina",
      "answer": "hullabaloo , ruckus",
      "ru": "Суматоха"
    },
    {
      "id": "965",
      "question": "esikoinen",
      "answer": "firstborn",
      "ru": "Первенец"
    },
    {
      "id": "966",
      "question": "harvinainen",
      "answer": "rare ",
      "ru": "Редкий"
    },
    {
      "id": "967",
      "question": "keikka",
      "answer": "a gig ",
      "ru": "Выступление"
    },
    {
      "id": "968",
      "question": "kuulua",
      "answer": "to belong to",
      "ru": "Принадлежать"
    },
    {
      "id": "969",
      "question": "hyödyntää",
      "answer": "to utilize ",
      "ru": "Использовать"
    },
    {
      "id": "970",
      "question": "työnjako",
      "answer": "division of work",
      "ru": "Разделение труда"
    },
    {
      "id": "971",
      "question": "syöpä",
      "answer": "cancer ",
      "ru": "Рак"
    },
    {
      "id": "972",
      "question": "sureminen",
      "answer": "mourning",
      "ru": "Траур"
    },
    {
      "id": "973",
      "question": "rinnalla",
      "answer": "beside",
      "ru": "Рядом"
    },
    {
      "id": "974",
      "question": "kiitollisuus",
      "answer": "gratitude ",
      "ru": "Благодарность"
    },
    {
      "id": "975",
      "question": "jakaa",
      "answer": "to share",
      "ru": "Делиться"
    },
    {
      "id": "976",
      "question": "kokoontua",
      "answer": "to gather ",
      "ru": "Собираться"
    },
    {
      "id": "977",
      "question": "syy",
      "answer": "cause, reason",
      "ru": "Причина"
    },
    {
      "id": "978",
      "question": "tasainen",
      "answer": "even ,flat",
      "ru": "Ровный"
    },
    {
      "id": "979",
      "question": "vastaan",
      "answer": "against, versus ",
      "ru": "Против"
    },
    {
      "id": "980",
      "question": "kuvailla",
      "answer": "to describe",
      "ru": "Описывать"
    },
    {
      "id": "981",
      "question": "utelias",
      "answer": "curious ",
      "ru": "Любопытный"
    },
    {
      "id": "982",
      "question": "liiaksi",
      "answer": "too much",
      "ru": "Слишком много"
    },
    {
      "id": "983",
      "question": "järkeillä ",
      "answer": "to argue ",
      "ru": "Рассуждать"
    },
    {
      "id": "984",
      "question": "elämänohje",
      "answer": "life instructions",
      "ru": "Жизненные советы"
    },
    {
      "id": "985",
      "question": "eläkeläinen",
      "answer": "retired person",
      "ru": "Пенсионер"
    },
    {
      "id": "986",
      "question": "seniori",
      "answer": "senior ",
      "ru": "Пожилой"
    },
    {
      "id": "987",
      "question": "ikäihminen",
      "answer": "aged person ",
      "ru": "Пожилой человек"
    },
    {
      "id": "988",
      "question": "iäkäs",
      "answer": "aged ",
      "ru": "Пожилой"
    },
    {
      "id": "989",
      "question": "vanhainkoti",
      "answer": "home for the aged ",
      "ru": "Дом престарелых"
    },
    {
      "id": "990",
      "question": "palvelutalo",
      "answer": "sheltered home",
      "ru": "Дом с обслуживанием"
    },
    {
      "id": "991",
      "question": "kotipalvelu",
      "answer": "home help service",
      "ru": "Домашняя помощь"
    },
    {
      "id": "992",
      "question": "kuolla",
      "answer": "to die ",
      "ru": "Умирать"
    },
    {
      "id": "993",
      "question": "saada surmansa",
      "answer": "to get killed",
      "ru": "Погибнуть"
    },
    {
      "id": "994",
      "question": "vainaja",
      "answer": "the deceased ",
      "ru": "Покойный"
    },
    {
      "id": "995",
      "question": "ruumis",
      "answer": "body , corpse",
      "ru": "Тело"
    },
    {
      "id": "996",
      "question": "sielu",
      "answer": "soul, spirit ",
      "ru": "Душа"
    },
    {
      "id": "997",
      "question": "arkku",
      "answer": "coffin ",
      "ru": "Гроб"
    },
    {
      "id": "998",
      "question": "uurna",
      "answer": "urn ",
      "ru": "Урна"
    },
    {
      "id": "999",
      "question": "hauta",
      "answer": "grave ",
      "ru": "Могила"
    },
    {
      "id": "1000",
      "question": "hautausmaa",
      "answer": "cemetery",
      "ru": "Кладбище"
    },
    {
      "id": "1001",
      "question": "siunaustilaisuus",
      "answer": "funeral service",
      "ru": "Траурная служба"
    },
    {
      "id": "1002",
      "question": "muistotilaisuus",
      "answer": "memorial service",
      "ru": "Поминки"
    },
    {
      "id": "1003",
      "question": "testamentti",
      "answer": "testment ",
      "ru": "Завещание"
    },
    {
      "id": "1004",
      "question": "perintö",
      "answer": "legacy, inheritance",
      "ru": "Наследство"
    },
    {
      "id": "1005",
      "question": "omainen",
      "answer": "a relative",
      "ru": "Родственник"
    },
    {
      "id": "1006",
      "question": "läheinen",
      "answer": "close, near",
      "ru": "Близкий"
    },
    {
      "id": "1007",
      "question": "vetäytyä",
      "answer": "to retire, pull out",
      "ru": "Удалиться"
    },
    {
      "id": "1008",
      "question": "hyötyä",
      "answer": "to benefit from ",
      "ru": "Извлекать пользу"
    },
    {
      "id": "1009",
      "question": "tyhmyys",
      "answer": "stupidity",
      "ru": "Глупость"
    },
    {
      "id": "1010",
      "question": "viitsiä",
      "answer": "to bother, care to",
      "ru": "Утруждаться"
    },
    {
      "id": "1011",
      "question": "synkkämielisyys",
      "answer": "melancholy ",
      "ru": "Меланхолия"
    },
    {
      "id": "1012",
      "question": "läski",
      "answer": "fat",
      "ru": "Жир"
    },
    {
      "id": "1013",
      "question": "raitis",
      "answer": "sober",
      "ru": "Трезвый"
    },
    {
      "id": "1014",
      "question": "väki",
      "answer": "people ",
      "ru": "Народ"
    },
    {
      "id": "1015",
      "question": "hermostuttaa",
      "answer": "to make nervous",
      "ru": "Нервировать"
    },
    {
      "id": "1016",
      "question": "paiskoa",
      "answer": "to throw things around",
      "ru": "Швырять"
    },
    {
      "id": "1017",
      "question": "järjestö",
      "answer": "organization ",
      "ru": "Организация"
    },
    {
      "id": "1018",
      "question": "farmaseutti",
      "answer": "pharmacist",
      "ru": "Фармацевт"
    },
    {
      "id": "1019",
      "question": "psykologi",
      "answer": "psychologist ",
      "ru": "Психолог"
    },
    {
      "id": "1020",
      "question": "fysioterapeutti ",
      "answer": "physiotherapist",
      "ru": "Физиотерапевт"
    },
    {
      "id": "1021",
      "question": "syrjäyttää",
      "answer": "to replace",
      "ru": "Вытеснять"
    },
    {
      "id": "1022",
      "question": "valtakunnallinen",
      "answer": "nationwide ",
      "ru": "Общенациональный"
    },
    {
      "id": "1023",
      "question": "pätevä",
      "answer": "valid ",
      "ru": "Компетентный"
    },
    {
      "id": "1024",
      "question": "koroton",
      "answer": "interest-free",
      "ru": "Беспроцентный"
    },
    {
      "id": "1025",
      "question": "kypsyä",
      "answer": "to age, ripen",
      "ru": "Созревать"
    },
    {
      "id": "1026",
      "question": "hikoilla",
      "answer": "to sweat ",
      "ru": "Потеть"
    },
    {
      "id": "1027",
      "question": "taikina",
      "answer": "dough",
      "ru": "Тесто"
    },
    {
      "id": "1028",
      "question": "rahka",
      "answer": "curd ",
      "ru": "Творог"
    },
    {
      "id": "1029",
      "question": "tilaus",
      "answer": "order ",
      "ru": "Заказ"
    },
    {
      "id": "1030",
      "question": "kehua",
      "answer": "to praise ",
      "ru": "Хвалить"
    },
    {
      "id": "1031",
      "question": "lyödä",
      "answer": "to beat ",
      "ru": "Бить"
    },
    {
      "id": "1032",
      "question": "sammaloitua",
      "answer": "to moss ",
      "ru": "Покрываться мхом"
    },
    {
      "id": "1033",
      "question": "makeinen",
      "answer": "sweet",
      "ru": "Конфета"
    },
    {
      "id": "1034",
      "question": "läpäistä",
      "answer": "to penetrate, pass ",
      "ru": "Проникать"
    },
    {
      "id": "1035",
      "question": "nyrkkeily",
      "answer": "boxing ",
      "ru": "Бокс"
    },
    {
      "id": "1036",
      "question": "siipi",
      "answer": "wing ",
      "ru": "Крыло"
    },
    {
      "id": "1037",
      "question": "livahtaa",
      "answer": "to slope, slip",
      "ru": "Проскользнуть"
    },
    {
      "id": "1038",
      "question": "raahata",
      "answer": "to drag ",
      "ru": "Тащить"
    },
    {
      "id": "1039",
      "question": "partio",
      "answer": "patrol ",
      "ru": "Патруль"
    },
    {
      "id": "1040",
      "question": "tarttua",
      "answer": "to catch, grab",
      "ru": "Схватить"
    },
    {
      "id": "1041",
      "question": "kasvillisuus",
      "answer": "vegetation",
      "ru": "Растительность"
    },
    {
      "id": "1042",
      "question": "lisääntyä",
      "answer": "to increase ",
      "ru": "Увеличиваться"
    },
    {
      "id": "1043",
      "question": "vaativa",
      "answer": "demanding ",
      "ru": "Требовательный"
    },
    {
      "id": "1044",
      "question": "valmistella",
      "answer": "to prepare ",
      "ru": "Подготавливать"
    },
    {
      "id": "1045",
      "question": "varmistaa",
      "answer": "to ensure",
      "ru": "Обеспечивать"
    },
    {
      "id": "1046",
      "question": "kulta",
      "answer": "gold",
      "ru": "Золото"
    },
    {
      "id": "1047",
      "question": "oikeastaan",
      "answer": "actually ",
      "ru": "Собственно говоря"
    },
    {
      "id": "1048",
      "question": "oikeasti",
      "answer": "really, correctly",
      "ru": "По-настоящему"
    },
    {
      "id": "1049",
      "question": "vatsa",
      "answer": "stomach",
      "ru": "Желудок"
    },
    {
      "id": "1050",
      "question": "poiketa",
      "answer": "to differ, deviate",
      "ru": "Отличаться"
    },
    {
      "id": "1051",
      "question": "elämys",
      "answer": "experience, adventure",
      "ru": "Впечатление"
    },
    {
      "id": "1052",
      "question": "kelvata",
      "answer": "to work, suffice",
      "ru": "Годиться"
    },
    {
      "id": "1053",
      "question": "vitsailla",
      "answer": "to joke",
      "ru": "Шутить"
    },
    {
      "id": "1054",
      "question": "selvittää",
      "answer": "to make clear",
      "ru": "Выяснять"
    },
    {
      "id": "1055",
      "question": "kasvihuone",
      "answer": "greenhouse",
      "ru": "Теплица"
    },
    {
      "id": "1056",
      "question": "seisova pöytä",
      "answer": "buffet table",
      "ru": "Шведский стол"
    },
    {
      "id": "1057",
      "question": "viljely",
      "answer": "cultivation ",
      "ru": "Выращивание"
    },
    {
      "id": "1058",
      "question": "täysin",
      "answer": "totally, fully, completely ",
      "ru": "Полностью"
    },
    {
      "id": "1059",
      "question": "perinne",
      "answer": "tradition ",
      "ru": "Традиция"
    },
    {
      "id": "1060",
      "question": "alue",
      "answer": "area, region to",
      "ru": "Область"
    },
    {
      "id": "1061",
      "question": "soveltua",
      "answer": "to fit ",
      "ru": "Подходить"
    },
    {
      "id": "1062",
      "question": "alava",
      "answer": "low-lying",
      "ru": "Низкий"
    },
    {
      "id": "1063",
      "question": "tasamaa",
      "answer": "flatland",
      "ru": "Равнина"
    },
    {
      "id": "1064",
      "question": "pohja",
      "answer": "base ",
      "ru": "Основа"
    },
    {
      "id": "1065",
      "question": "ravinteikas",
      "answer": "nutritious",
      "ru": "Питательный"
    },
    {
      "id": "1066",
      "question": "kaikkiaan",
      "answer": "in all, altogether",
      "ru": "В целом"
    },
    {
      "id": "1067",
      "question": "hehtaari",
      "answer": "hectare",
      "ru": "Гектар"
    },
    {
      "id": "1068",
      "question": "laajuus",
      "answer": "scope ",
      "ru": "Масштаб"
    }
  ];

export default vocabulary_B2;